window.wpbingo = window.wpbingo || {};

wpbingo.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on("shopify:section:load", this._onSectionLoad.bind(this))
    .on("shopify:section:unload", this._onSectionUnload.bind(this))
    .on("shopify:section:select", this._onSelect.bind(this))
    .on("shopify:section:deselect", this._onDeselect.bind(this))
    .on("shopify:block:select", this._onBlockSelect.bind(this))
    .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
};

wpbingo.Sections.prototype = _.assignIn({}, wpbingo.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var $container = $(container);
    var id = $container.attr("data-section-id");
    var type = $container.attr("data-section-type");
    constructor = constructor || this.constructors[type];
    if (_.isUndefined(constructor)) {
      return;
    }
    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container,
    });
    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = $("[data-section-id]", evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    this.instances = _.filter(this.instances, function (instance) {
      var isEventInstance = instance.id === evt.originalEvent.detail.sectionId;
      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }
      return !isEventInstance;
    });
  },

  _onSelect: function (evt) {
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });
    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });
    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function (evt) {
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });
    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });
    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;
    $("[data-section-type=" + type + "]").each(
      function (index, container) {
        this._createInstance(container, constructor);
      }.bind(this),
    );
  },
});

wpbingo.LibraryLoader = (function () {
  var types = {
    link: "link",
    script: "script",
  };
  var status = {
    requested: "requested",
    loaded: "loaded",
  };
  var cloudCdn = "https://cdn.shopify.com/shopifycloud/";
  var libraries = {
    youtubeSdk: {
      tagId: "youtube-sdk",
      src: "https://www.youtube.com/iframe_api",
      type: types.script,
    },
    plyrShopifyStyles: {
      tagId: "plyr-shopify-styles",
      src: cloudCdn + "shopify-plyr/v1.0/shopify-plyr.css",
      type: types.link,
    },
    modelViewerUiStyles: {
      tagId: "shopify-model-viewer-ui-styles",
      src: cloudCdn + "model-viewer-ui/assets/v1.0/model-viewer-ui.css",
      type: types.link,
    },
  };

  function load(libraryName, callback) {
    var library = libraries[libraryName];
    if (!library) return;
    if (library.status === status.requested) return;
    callback = callback || function () {};
    if (library.status === status.loaded) {
      callback();
      return;
    }
    library.status = status.requested;
    var tag;
    switch (library.type) {
      case types.script:
        tag = createScriptTag(library, callback);
        break;
      case types.link:
        tag = createLinkTag(library, callback);
        break;
    }
    tag.id = library.tagId;
    library.element = tag;
    var firstScriptTag = document.getElementsByTagName(library.type)[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  function createScriptTag(library, callback) {
    var tag = document.createElement("script");
    tag.src = library.src;
    tag.addEventListener("load", function () {
      library.status = status.loaded;
      callback();
    });
    return tag;
  }

  function createLinkTag(library, callback) {
    var tag = document.createElement("link");
    tag.href = library.src;
    tag.rel = "stylesheet";
    tag.type = "text/css";
    tag.addEventListener("load", function () {
      library.status = status.loaded;
      callback();
    });
    return tag;
  }

  return {
    load: load,
  };
})();

wpbingo.Currency = (function () {
  var moneyFormat = "${{amount}}";
  function formatMoney(cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ",";
      decimal = decimal || ".";
      if (isNaN(number) || number === null) {
        return 0;
      }
      number = (number / 100.0).toFixed(precision);
      var parts = number.split(".");
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }
    return formatString.replace(placeholderRegex, value);
  }
  return {
    formatMoney: formatMoney,
  };
})();

wpbingo.Variants = (function () {
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.productSelectOption = options.productSelectOption;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();
    $(this.singleOptionSelector, this.$container).on("change", this._onSelectChange.bind(this));
  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {
    _getCurrentOptions: function () {
      var currentOptions = _.map($(this.singleOptionSelector, this.$container), function (element) {
        var $element = $(element);
        var type = $element.attr("type");
        var currentOption = {};
        if (type === "radio" || type === "checkbox") {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data("index");
            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data("index");
          return currentOption;
        }
      });
      currentOptions = _.compact(currentOptions);
      return currentOptions;
    },

    _getVariantFromOptions: function () {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = _.find(variants, function (variant) {
        return selectedValues.every(function (values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });
      return found;
    },

    _onSelectChange: function () {
      var variant = this._getVariantFromOptions();
      if ($("[data-single-option-button]", this.$container).length && $(".color-select", this.$container).length < 1) {
        this._updateVariantsButton();
        if (!variant || !variant.available) {
          this._updateVariantsButtonDisabed();
          return;
        }
      }
      this.$container.trigger({
        type: "variantChange",
        variant: variant,
      });
      if (!variant) return;
      this._updateMasterSelect(variant);
      this._updateMedia(variant);
      this._updatePrice(variant);
      this._updateQuantity(variant);
      this._updateOption(variant);
      this._updatePricesticky(variant);
      this._updateSKU(variant);
      this._updateLabelvariant(variant);
      this.currentVariant = variant;
      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    _updateVariantsButtonDisabed: function () {
      for (var i = 2; i <= 3; i++) {
        if ($(this.productSelectOption + i, this.$container).length) {
          var isUpdate = false;
          $(this.productSelectOption + i + " " + this.singleOptionSelector, this.$container).each(function () {
            var $element = $(this);
            var type = $element.attr("type");
            if (type === "radio" || type === "checkbox") {
              if (this.checked && $element.hasClass("disabled")) {
                $element.prop("checked", false);
                isUpdate = true;
                return false;
              }
            }
          });
          $(this.productSelectOption + i + " " + this.singleOptionSelector, this.$container).each(function () {
            var $element = $(this);
            var type = $element.attr("type");
            if (isUpdate && (type === "radio" || type === "checkbox") && !$element.hasClass("disabled")) {
              $element.prop("checked", true);
              isUpdate = false;
              $element.trigger("change");
              return false;
            }
          });
        }
      }
    },

    _updateVariantsButton: function () {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      for (var i = 2; i <= 3; i++) {
        if ($(this.productSelectOption + i, this.$container).length) {
          var $parent = this.productSelectOption + i;
          $($parent + " " + this.singleOptionSelector, this.$container).each(function () {
            var $self = $(this);
            var optionValue = $self.val();
            var foundIndex;
            if (i === 2) {
              foundIndex = _.findIndex(variants, function (variant) {
                variant.option1 = variant.option1.toString();
                selectedValues[0].value = selectedValues[0].value.toString();
                variant.option2 = variant.option2.toString();
                optionValue = optionValue.toString();
                return variant.option1 === selectedValues[0].value && variant.option2 === optionValue && variant.available === true;
              });
            } else if (i === 3) {
              foundIndex = _.findIndex(variants, function (variant) {
                variant.option1 = variant.option1.toString();
                variant.option2 = variant.option2.toString();
                variant.option3 = variant.option3.toString();
                selectedValues[0].value = selectedValues[0].value.toString();
                selectedValues[1].value = selectedValues[1].value.toString();
                optionValue = optionValue.toString();
                return (
                  variant.option1 === selectedValues[0].value &&
                  variant.option2 === selectedValues[1].value &&
                  variant.option3 === optionValue &&
                  variant.available === true
                );
              });
            }
            if (foundIndex !== -1) {
              if ($($parent + ".color-select", this.$container).length > 0) {
                $self.removeClass("disabled");
                $self.next("label").removeClass("disabled");
              } else {
                $self.removeAttr("disabled", "disabled").removeClass("disabled");
                $self.next("label").removeClass("disabled");
              }
            } else {
              if ($($parent + ".color-select", this.$container).length > 0) {
                $self.addClass("disabled");
                $self.next("label").addClass("disabled");
              } else {
                $self.attr("disabled", "disabled").addClass("disabled");
                $self.next("label").addClass("disabled");
              }
            }
          });
        }
      }
    },

    _updateMedia: function (variant) {
      var variantMedia = variant.featured_media || {};
      var currentVariantMedia = this.currentVariant.featured_media || {};
      var isMatchingPreviewImage = false;
      if (variantMedia.preview_image && currentVariantMedia.preview_image) {
        isMatchingPreviewImage = variantMedia.preview_image.src === currentVariantMedia.preview_image.src;
      }
      if (!variant.featured_media || isMatchingPreviewImage) return;
      this.$container.trigger({
        type: "variantMediaChange",
        variant: variant,
      });
    },

    _updatePrice: function (variant) {
      if ($(".bwp_currency").length > 0) {
        Currency.Currency_customer(true);
      }
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }
      this.$container.trigger({
        type: "variantPriceChange",
        variant: variant,
      });
    },

    _updateQuantity: function (variant) {
      if ($(".product-single .content-variant_inventory").length > 0) {
        setTimeout(function () {
          $(".product-single .content-variant_inventory").load(window.location.href + ".content-variant_inventory .js-product-avaiable");
        }, 10);
      }
    },

    _updateOption: function () {
      setTimeout(function () {
        // $("#option-selector").load(window.location.href + " #option-selector");
        $.get(window.location.href, function (response) {
          const newVariantOptions = $(response).find("#option-selector").html();

          $("#option-selector").html(newVariantOptions);
        });
      }, 10);
    },

    _updatePricesticky: function () {
      setTimeout(function () {
        // $("#price-sticky").load(window.location.href + " #price-sticky");
        $.get(window.location.href, function (response) {
          const newVariantPrice = $(response).find("#price-sticky").html();

          $("#price-sticky").html(newVariantPrice);
        });
      }, 10);
    },

    _updatePricesticky: function () {
      if ($("body").attr("id") != "seasonal-subscription") {
        setTimeout(function () {
          // $("#price-sticky").load(window.location.href + " #price-sticky");
          $.get(window.location.href, function (response) {
            const newVariantPrice = $(response).find("#price-sticky").html();

            $("#price-sticky").html(newVariantPrice);
          });
        }, 10);
      }
    },

    _updateSKU: function (variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }
      this.$container.trigger({
        type: "variantSKUChange",
        variant: variant,
      });
    },
    _updateLabelvariant: function (variant) {
      var $element = $(".product-single .product-single__form .variants-wrapper");
      $(".mutil_slider-single").removeClass("active");
      $($element).each(function () {
        var $this = $(this);
        if ($("select", $this).length > 0) {
          var value = $("select", $this).find(":selected").val();
        } else {
          var value = $("input:checked", $this).attr("value");
        }
        $(".variants__label span", $this).html(value);
        $(".mutil_slider-single." + value + "").addClass("active");
      });
    },
    _updateHistoryState: function (variant) {
      if (!history.replaceState || !variant) {
        return;
      }
      var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + variant.id;
      window.history.replaceState({ path: newurl }, "", newurl);
    },
    _updateMasterSelect: function (variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    },
  });

  return Variants;
})();

wpbingo.ProductModel = (function () {
  var modelJsonSections = {};
  var models = {};
  var xrButtons = {};
  var selectors = {
    productMediaGroup: ".js-product-media-group",
    productMediaGroupWrapper: ".js-product-single-media",
    xrButton: "[data-shopify-xr]",
    xrButtonSingle: "[data-shopify-xr-single]",
  };

  var classes = {
    viewInSpaceDisabled: "product-single__view-in-space--disabled",
  };

  function init(modelViewerContainers, sectionId) {
    modelJsonSections[sectionId] = {
      loaded: false,
    };

    modelViewerContainers.each(function (index) {
      var $modelViewerContainer = $(this);
      var mediaId = $modelViewerContainer.data("media-id");
      var $modelViewerElement = $($modelViewerContainer.find("model-viewer")[0]);
      var modelId = $modelViewerElement.data("model-id");

      if (index === 0) {
        var $xrButton = $modelViewerContainer.closest(selectors.productMediaGroupWrapper).find(selectors.xrButtonSingle);

        xrButtons[sectionId] = {
          $element: $xrButton,
          defaultId: modelId,
        };
      }

      models[mediaId] = {
        modelId: modelId,
        sectionId: sectionId,
        $container: $modelViewerContainer,
        $element: $modelViewerElement,
      };
    });

    window.Shopify.loadFeatures([
      {
        name: "shopify-xr",
        version: "1.0",
        onLoad: setupShopifyXr,
      },
    ]);

    if (models.length < 1) return;
    window.Shopify.loadFeatures([
      {
        name: "model-viewer-ui",
        version: "1.0",
        onLoad: setupModelViewerUi,
      },
    ]);
    wpbingo.LibraryLoader.load("modelViewerUiStyles");
  }

  function setupShopifyXr(errors) {
    if (errors) return;
    if (!window.ShopifyXR) {
      document.addEventListener("shopify_xr_initialized", function (event) {
        if (event.detail.shopifyXREnabled) {
          setupShopifyXr();
        } else {
          $(selectors.xrButton).addClass(classes.viewInSpaceDisabled);
        }
      });
      return;
    }

    for (var sectionId in modelJsonSections) {
      if (modelJsonSections.hasOwnProperty(sectionId)) {
        var modelSection = modelJsonSections[sectionId];
        if (modelSection.loaded) continue;
        var $modelJson = $("#ModelJson-" + sectionId);
        window.ShopifyXR.addModels(JSON.parse($modelJson.html()));
        modelSection.loaded = true;
      }
    }
    window.ShopifyXR.setupXRElements();
  }

  function setupModelViewerUi(errors) {
    if (errors) return;
    for (var key in models) {
      if (models.hasOwnProperty(key)) {
        var model = models[key];
        if (!model.modelViewerUi) {
          model.modelViewerUi = new Shopify.ModelViewerUI(model.$element);
        }
        setupModelViewerListeners(model);
      }
    }
  }

  function setupModelViewerListeners(model) {
    var xrButton = xrButtons[model.sectionId];
    var $productMediaGroup = model.$container.closest(selectors.productMediaGroup);

    model.$element
      .on("shopify_model_viewer_ui_toggle_play", function () {
        wpbingo.updateSlickSwipe($productMediaGroup, false);
      })
      .on("shopify_model_viewer_ui_toggle_pause", function () {
        wpbingo.updateSlickSwipe($productMediaGroup, true);
      });

    model.$container.on("mediaVisible", function () {
      xrButton.$element.attr("data-shopify-model3d-id", model.modelId);
      model.modelViewerUi.play();
    });

    model.$container
      .on("mediaHidden", function () {
        xrButton.$element.attr("data-shopify-model3d-id", xrButton.defaultId);
        model.modelViewerUi.pause();
      })
      .on("xrLaunch", function () {
        model.modelViewerUi.pause();
      });
  }

  function removeSectionModels(sectionId) {
    for (var key in models) {
      if (models.hasOwnProperty(key)) {
        var model = models[key];
        if (model.sectionId === sectionId) {
          models[key].modelViewerUi.destroy();
          delete models[key];
        }
      }
    }
    delete modelJsonSections[sectionId];
  }

  return {
    init: init,
    removeSectionModels: removeSectionModels,
  };
})();

// PRODUCT SECTION
wpbingo.Product = (function () {
  function Product(container) {
    var $window = $(window);
    var $container = (this.$container = $(container));
    var sectionId = $container.attr("data-section-id");
    this.settings = {
      productPageLoad: false,
      preloadImage: false,
      enableHistoryState: $container.data("enable-history-state"),
      namespace: ".productSection",
      sectionId: sectionId,
    };
    this.selectors = {
      productMediaGroup: ".js-product-media-group",
      productMediaGroupItem: ".js-product-media-item",
      productMediaWrapper: ".js-product-media",
      productMediaTypeModel: "[data-product-media-type-model]",
      productMediaTypeVideo: "[data-product-media-type-video]",
      productThumbnails: ".js-product-thumbnails",
      buyTogether: ".buy-together-products",
      productThumbnail: "[data-product-thumbnail]",
      productImageZoom: "[data-mfp-src]",
      meta: ".product-single__meta",
      productWrapper: ".product-single",
      productSelectOption: ".js-product-select-option--",
      originalSelectorId: ".js-product-select",
      singleOptionSelector: ".js-single-option-selector",
      slickDots: "[data-slick-dots]",
      slickNext: "[data-slick-next]",
      slickPrevious: "[data-slick-previous]",
      variantColor: "[data-color]",
    };
    this.classes = {
      hide: "d-none",
      priceContainerUnitAvailable: "price-container--unit-available",
      productInventoryInStock: "product-avaiable__text--instock",
      productInventoryOutStock: "product-avaiable__text--outstock",
    };
    this.slickMediaSettings = {
      slide: this.selectors.productMediaGroupItem,
      rows: 0,
      accessibility: true,
      arrows: true,
      appendDots: this.selectors.slickDots,
      prevArrow: this.selectors.slickPrevious,
      nextArrow: this.selectors.slickNext,
      dots: true,
      rtl: wpbingo.rtl_slick(),
      infinite: $(this.selectors.productMediaGroup).data("infinite") ? true : false,
      draggable: $(this.selectors.productMediaGroup).data("draggable") ? true : false,
      adaptiveHeight: true,
      fade: $(this.selectors.productMediaGroup).data("fade") ? true : false,
      customPaging: function (slick, index) {
        var slideA11yString = wpbingo.strings.productSlideLabel.replace("[slide_number]", index + 1).replace("[slide_max]", slick.slideCount);

        var mediaA11yString = $('[data-slick-index="' + index + '"]', this.$container).data("slick-media-label");

        var isSelected = index === 0;

        return (
          '<a href="javascript:void(0)"' +
          ' role="tab"' +
          ' id="slick-tab2' +
          index +
          '"' +
          ' aria-label="' +
          slideA11yString +
          " " +
          mediaA11yString +
          '"' +
          ' aria-controls="slick-slide2' +
          index +
          '"' +
          ' aria-selected="' +
          isSelected +
          '"' +
          ' tabindex="' +
          (isSelected ? "0" : "-1") +
          '"' +
          "></a>"
        );
      }.bind(this),
    };
    if (!$("#ProductJson-" + sectionId).html()) {
      return;
    }
    this.productSingleObject = JSON.parse(document.getElementById("ProductJson-" + sectionId).innerHTML);

    this.zoomType = $container.data("image-zoom-type");
    this.isStackedLayout = $container.data("stacked-layout");
    this.isNothumLayout = $container.data("nothum");
    this.focusableElements = ["iframe", "input", "button", "video", '[tabindex="0"]'].join(",");

    this.slickThumbsSettings = {
      slidesToShow: $(this.selectors.productThumbnails).data("columns"),
      slidesToScroll: 1,
      rows: 0,
      accessibility: true,
      arrows: true,
      dots: false,
      infinite: false,
      focusOnSelect: true,
      adaptiveHeight: true,
      rtl: $("body").hasClass("rtl") && !$(this.selectors.productThumbnails).data("vertical") ? true : false,
      vertical: $(this.selectors.productThumbnails).data("vertical") ? true : false,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 4,
            vertical: false,
          },
        },
      ],
    };

    if (
      !this.isStackedLayout &&
      !this.isNothumLayout &&
      $(this.selectors.productMediaGroup, this.$container) &&
      $(this.selectors.productThumbnails, this.$container)
    ) {
      this.slickMediaSettings.asNavFor = this.selectors.productThumbnails + "-" + sectionId;
      this.slickThumbsSettings.asNavFor = this.selectors.productMediaGroup + "-" + sectionId;
    } else {
      if ($(window).width() < 991 && $(this.selectors.productWrapper).data("layout_thumb") == "gird-sticky") {
        this.slickMediaSettings.asNavFor = this.selectors.productThumbnails + "-" + sectionId;
        this.slickThumbsSettings.asNavFor = this.selectors.productMediaGroup + "-" + sectionId;
      }
    }
    this.view_gallery_product();
    this.event_group_product();
    this.initBreakpoints();
    this.initProductVariant();
    this.initModelViewerLibraries();
    this.initShopifyXrLaunch();
    this.initStickyProductMeta();
    this.count_view_product();
    this.count_sale_product();
    this.percent_sale_product();
    this.delivery_return();
    this.ask_a_question();
    this.back_in_stock();
    this.single_product_share();
    this.gallery_cursor();
    this.sticky_gird();
    this.sticky_sidebar();
    this.image_360();
    this.tab_information();

    var $element = $(".product-single");
    var _data = $element.data();
    $(".product-single__video img").css("width", $(".product-single__thumbnail img").width());
    $(".product-single__video img").css("height", $(".product-single__thumbnail img").height() - 2.5);
    $window
      .on("load" + this.settings.namespace, wpbingo.initStickyProductMeta)
      .on("resize" + this.settings.namespace, wpbingo.debounce(this.initStickyProductMeta, 150).bind(this));
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    initBreakpoints: function () {
      var self = this;
      if (!self.isStackedLayout) {
        self.createMediaCarousel();
        self.createThumbnailCarousel();
      } else {
        if ($(window).width() < 991) {
          self.createMediaCarousel();
          self.createThumbnailCarousel();
        } else {
          enquire.register(wpbingo.variables.mediaMobile, {
            match: function () {
              self.createMediaCarousel();
            },
            unmatch: function () {
              self.destroyMediaCarousel();
            },
          });
        }
      }
    },
    initProductVariant: function () {
      var options = {
        $container: this.$container,
        enableHistoryState: this.settings.enableHistoryState || false,
        productSelectOption: this.selectors.productSelectOption,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId + "--" + this.settings.sectionId,
        product: this.productSingleObject,
      };
      var count = $(this.selectors.productThumbnails, this.$container).data("columns");
      this.variants = new wpbingo.Variants(options);
      var featured_media = this.variants.currentVariant.featured_media;
      if (
        !$(".js-product-single-media").hasClass("no-variants") &&
        !$(".js-product-single-media >.row").hasClass("mutil_slider-single") &&
        featured_media
      ) {
        this.showVariantMedia(this.variants.currentVariant, true);
      }
      this.$container.on("variantChange" + this.settings.namespace, this.productPage.bind(this));
      this.$container.on("variantMediaChange" + this.settings.namespace, this.showVariantMedia.bind(this));
      // if (this.variants.product.media.length <= count) {
      //   $(this.selectors.productThumbnails, this.$container).addClass("no-transform");
      // }
    },
    initModelViewerLibraries: function () {
      if (!this.$container.data("has-model")) return;
      var $modelViewerElements = $(this.selectors.productMediaTypeModel, this.$container);
      wpbingo.ProductModel.init($modelViewerElements, this.settings.sectionId);
    },

    initShopifyXrLaunch: function () {
      $(document).on(
        "shopify_xr_launch",
        function () {
          var $currentMedia = $(this.selectors.productMediaWrapper + ":not(." + this.classes.hide + ")", this.$container);
          $currentMedia.trigger("xrLaunch");
        }.bind(this),
      );
    },

    trapCarouselFocus: function ($slider, removeFocusTrap) {
      if (!$slider) return;

      $slider
        .find(".slick-slide:not(.slick-active)")
        .find(this.focusableElements)
        .attr("tabindex", removeFocusTrap ? "0" : "-1");

      $slider.find(".slick-active").find(this.focusableElements).attr("tabindex", "0");
    },

    updateCarouselSlidesA11y: function (currentSlide) {
      var $slides = $(this.selectors.productMediaGroup, this.$container).find(".slick-slide").not(".slick-cloned");

      $slides.each(function () {
        var $slide = $(this);
        var index = Number($slide.attr("data-slick-index"));

        $slide.attr({
          role: "tabpanel",
          "aria-labelledby": "slick-tab0" + index,
          tabindex: index === currentSlide ? "0" : "-1",
          "aria-hidden": index === currentSlide ? "false" : "true",
        });
      });
    },

    // updateCarouselDotsA11y: function (nextSlide) {
    //   var $dotLinks = $(this.selectors.slickDots).find("a");
    //   $dotLinks.removeAttr("aria-current").eq(nextSlide).attr("aria-current", "true");
    // },

    updateCarouselDotsA11y: function (nextSlide) {
      var $dotLinks = $(this.selectors.slickDots).find("a");

      $dotLinks.attr({
        "aria-selected": "false",
        tabindex: "-1",
      });

      $dotLinks.eq(nextSlide).attr({
        "aria-selected": "true",
        tabindex: "0",
      });
    },

    view_gallery_product: function () {
      $element = $(".product-single");
      $(".product-media__wrapper.product-media__wrapper--image", $element).bind("click", function (e) {
        e.preventDefault();
        var groups = $(this).closest(".js-product-media-group");
        var items = [];
        var gallery = [];
        var $j = 0;
        var $i = 0;
        $(".js-product-media-item", groups).each(function () {
          $("img", $(this)).data("number", $j);
          if ($("img", $(this)).data("image") == true) {
            var $href = $("img", $(this)).attr("src");
            if ($href) {
              gallery[$j] = { href: $href };
              $j++;
            }
          }
        });
        if (gallery) {
          $.each(gallery, function (key, value) {
            if (value) {
              items[$i] = { src: value.href, w: $(".mfp-image", $element).width() * 3, h: $(".mfp-image", $element).height() * 3 };
              $i++;
            }
          });
          var pswpElement = document.querySelectorAll(".pswp")[0];
          var options = {
            index: $("img", $(this)).data("number"),
            closeOnScroll: false,
            history: false,
            shareEl: false,
          };
          var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
          gallery.init();
        }
      });
    },

    event_group_product: function () {
      $("#group_table_product .add-group-to-cart").on("click", function (e) {
        e.preventDefault();
        $(this).removeClass("added");
        $(this).addClass("active");
        let addToCartForm = document.querySelector("#group_table_product");
        let formData = new FormData(addToCartForm);
        var params = {
          type: "POST",
          url: "/cart/add.js",
          data: formData,
          processData: false,
          contentType: false,
          dataType: "json",
          success: function (line_item) {
            $("#group_table_product .add-group-to-cart").removeClass("active");
            $("#group_table_product .add-group-to-cart").addClass("added");
            setTimeout(function () {
              $("#group_table_product .add-group-to-cart").removeClass("added");
            }, 3000);
            ajaxCart.load();
            if ($(".js-drawer").length) {
              $("body").addClass("drawer--open");
              $(".js-drawer").focus();
              $(".js-drawer.tend-side-cart").attr("aria-hidden", "false");
            }
            $(".js-drawer-close").on("click", function () {
              $("body").removeClass("drawer--open");
              $(".js-header-cart").focus();
              $(".js-drawer.tend-side-cart").attr("aria-hidden", "true");
            });
          },
          error: function (XMLHttpRequest, textStatus) {
            if (typeof errorCallback === "function") {
              errorCallback(XMLHttpRequest, textStatus);
            } else {
              ShopifyAPI.onError(XMLHttpRequest, textStatus);
            }
          },
        };
        jQuery.ajax(params);
      });
    },

    translateCarouselDots: function (totalSlides, nextSlide, dotStyle) {
      if (totalSlides <= dotStyle.max) {
        return;
      }
      var calculatedTranslateDistance = 0;
      var maxTranslateDistance = (totalSlides - dotStyle.max) * dotStyle.width;
      if (nextSlide >= dotStyle.max - 1) {
        calculatedTranslateDistance = (nextSlide + 2 - dotStyle.max) * dotStyle.width;
        calculatedTranslateDistance = maxTranslateDistance < calculatedTranslateDistance ? maxTranslateDistance : calculatedTranslateDistance;
      }
      $(this.selectors.slickDots)
        .find("ul")
        .css("transform", "translateX(-" + calculatedTranslateDistance + "px)");
    },

    triggerMediaChangeEvent: function (mediaId) {
      var $otherMedia = $(this.selectors.productMediaWrapper, this.$container);
      $otherMedia.trigger("mediaHidden");
      var $newMedia = $(this.selectors.productMediaWrapper, this.$container).filter('[data-media-id="' + mediaId + '"]');
      $newMedia.trigger("mediaVisible");
    },

    showVariantMedia: function (evt, check) {
      if (check) {
        var variant = evt;
      } else {
        var variant = evt.variant;
      }
      var variantMediaId = this.settings.sectionId + "-" + variant.featured_media.id;
      var $newMedia = $(this.selectors.productMediaWrapper + '[data-media-id="' + variantMediaId + '"]');
      this.triggerMediaChangeEvent(variantMediaId);

      var mediaIndex;

      if (!wpbingo.variables.isMobile && this.isStackedLayout) {
        mediaIndex = $newMedia.closest(".slick-slide").index();
        if (mediaIndex !== 0 || wpbingo.variables.productPageLoad) {
          if (wpbingo.variables.productPageSticky) {
            $("html, body").animate(
              {
                scrollTop: $newMedia.offset().top,
              },
              250,
            );
          } else {
            var currentScroll = $(document).scrollTop();
            $newMedia
              .closest($(this.selectors.productMediaGroupItem, this.$container))
              .prependTo($(this.selectors.productMediaGroup, this.$container));
            $(document).scrollTop(currentScroll);
          }
        }
      } else {
        mediaIndex = $newMedia.closest(".slick-slide").data("slick-index");
        if (_.isUndefined(mediaIndex)) {
          return;
        }
        if (mediaIndex !== 0 || wpbingo.variables.productPageLoad) {
          $(this.selectors.productMediaGroup, this.$container).slick("slickGoTo", mediaIndex);
        }
      }
      if (!wpbingo.variables.productPageLoad) {
        wpbingo.variables.productPageLoad = true;
      }
    },

    setFeaturedMedia: function () {
      var mediaId = $(this.selectors.productMediaGroup, this.$container)
        .find(".slick-slide.slick-current.slick-active " + this.selectors.productMediaWrapper)
        .attr("data-media-id");
      this.triggerMediaChangeEvent(mediaId);
    },

    createMediaCarousel: function () {
      if ($(this.selectors.productMediaGroupItem).length < 2 || !$(this.selectors.productMediaGroup, this.$container) || this.isCarouselActive) {
        return;
      }
      this.isCarouselActive = true;
      var dotStyle = {
        max: 9,
        width: 20,
      };
      var focusTrapped = false;
      $(this.selectors.productMediaGroupItem, this.$container).on(
        "focusin",
        function () {
          if (focusTrapped) {
            return;
          }
          this.trapCarouselFocus($(this.selectors.productMediaGroup));
          focusTrapped = true;
        }.bind(this),
      );
      if ($(".mutil_slider-single").length > 0) {
        var sectionId = this.settings.sectionId;
        var $config = this.slickMediaSettings;
        if (
          !this.isStackedLayout &&
          !this.isNothumLayout &&
          $(this.selectors.productMediaGroup, this.$container) &&
          $(this.selectors.productThumbnails, this.$container)
        ) {
          var asNavFor = true;
        }
        $(".mutil_slider-single").each(function (index) {
          $config["nextArrow"] = $("[data-slick-next]", $(this));
          $config["prevArrow"] = $("[data-slick-previous]", $(this));
          if (asNavFor) {
            $config["asNavFor"] = ".js-product-thumbnails" + "-" + sectionId + "-" + (index + 1);
          }
          $(".js-product-media-group", $(this)).slick($config);
        });
      } else {
        /*$(this.selectors.productMediaGroup, this.$container)
          .slick(this.slickMediaSettings)
          .on(
            "init",
            function () {
              $(this.selectors.slickDots).find("ul").attr("role", "tablist");

              $(this.selectors.slickDots).find("li").attr("role", "presentation");
            }.bind(this),
          )
          .on(
            "beforeChange",
            function (event, slick, currentSlide, nextSlide) {
              this.updateCarouselDotsA11y(nextSlide);
              this.translateCarouselDots(slick.slideCount, nextSlide, dotStyle);
            }.bind(this),
          );*/

        var $ProductSlider = $(this.selectors.productMediaGroup, this.$container);

        $ProductSlider.slick(this.slickMediaSettings);

        this.updateCarouselSlidesA11y(0);

        $(this.selectors.productMediaGroup, this.$container).find(".slick-cloned").attr({
          "aria-hidden": "true",
          tabindex: "-1",
        });

        $(this.selectors.productMediaGroup, this.$container).attr({
          role: "region",
          "aria-roledescription": "carousel",
          "aria-label": this.productSingleObject.title + " media gallery",
        });

        $(this.selectors.slickDots).find("ul").attr("role", "tablist");

        $(this.selectors.slickDots).find("li").attr("role", "presentation");

        $ProductSlider.on(
          "beforeChange",
          function (event, slick, currentSlide, nextSlide) {
            this.updateCarouselDotsA11y(nextSlide);
            this.updateCarouselSlidesA11y(nextSlide);
            this.translateCarouselDots(slick.slideCount, nextSlide, dotStyle);
          }.bind(this),
        );
      }
    },

    destroyMediaCarousel: function () {
      if (!$(this.selectors.productMediaGroup, this.$container).length || !this.isCarouselActive) {
        return;
      }
      this.trapCarouselFocus($(this.selectors.productMediaGroup, this.$container), true);
      $(this.selectors.productMediaGroup, this.$container).slick("unslick");
      this.isCarouselActive = false;
    },

    createThumbnailCarousel: function () {
      if ($(".mutil_slider-single").length > 0) {
        var sectionId = this.settings.sectionId;
        var $configThumb = this.slickThumbsSettings;
        if (
          !this.isStackedLayout &&
          !this.isNothumLayout &&
          $(this.selectors.productMediaGroup, this.$container) &&
          $(this.selectors.productThumbnails, this.$container)
        ) {
          var asNavFor = true;
        }
        $(".mutil_slider-single").each(function (index) {
          if (asNavFor) {
            $configThumb.asNavFor = ".js-product-media-group" + "-" + sectionId + "-" + (index + 1);
          }
          $(".js-product-thumbnails", $(this)).slick($configThumb);
        });
      } else {
        $(this.selectors.productThumbnails, this.$container).slick(this.slickThumbsSettings);
      }
    },

    initStickyProductMeta: function () {
      var $meta = $(this.selectors.meta, this.$container);
      var $wrapper = $(this.selectors.productWrapper, this.$container);
      if (!$meta.length || $(this.selectors.productMediaWrapper, this.$container).length < 2) {
        return;
      }
      $meta.trigger("detach.ScrollToFixed");
      if (wpbingo.variables.isMobile) {
        return;
      }
      var productCopyHeight = $meta.outerHeight();
      var productMediaGroupHeight = $(this.selectors.productMediaGroup, this.$container).height();
      var calcLimit = $wrapper.offset().top + $wrapper.height();
      calcLimit -= productCopyHeight;
      if (productCopyHeight < productMediaGroupHeight && productCopyHeight < $(window).height()) {
        wpbingo.variables.productPageSticky = true;
        $meta.scrollToFixed({
          limit: calcLimit,
        });
      } else {
        wpbingo.variables.productPageSticky = false;
      }
    },

    getBaseUnit: function (variant) {
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value + variant.unit_price_measurement.reference_unit;
    },

    productPage: function (evt) {
      var moneyFormat = wpbingo.strings.moneyFormat;
      var variant = evt.variant;
      var translations = wpbingo.strings;
      var selectors = {
        addToCart: ".btn--add-to-cart",
        addToCartText: ".btn--add-to-cart .btn__text",
        quantityElements: ".js-quantity-selector",
        shopifyPaymentButton: ".shopify-payment-button",
        priceContainer: "[data-price-container]",
        productPrice: ".js-product-price",
        priceA11y: ".js-product-price-a11y",
        comparePrice: ".js-product-compare-price",
        comparePriceA11y: ".js-product-compare-price-a11y",
        comparePriceWrapper: ".product-single__price--wrapper",
        productAvailable: ".js-product-avaiable",
        productAvailableText: ".js-product-avaiable-text",
        unitPrice: "[data-unit-price]",
        unitPriceBaseUnit: "[data-unit-price-base-unit]",
        SKU: ".js-variant-sku",
      };
      if (variant) {
        $(selectors.priceContainer, this.$container).removeClass(this.classes.hide);
        $(selectors.productAvailable, this.$container).removeClass(this.classes.hide);
        $(selectors.productPrice, this.$container).attr("aria-hidden", "false");
        $(selectors.priceA11y, this.$container).attr("aria-hidden", "false");
        if (variant.available) {
          $(selectors.addToCart, this.$container).removeClass("disabled").prop("disabled", false);
          $(selectors.addToCartText, this.$container).find(".btn_text").text(translations.addToCart);
          $(selectors.productAvailableText)
            .removeClass(this.classes.productInventoryOutStock)
            .addClass(this.classes.productInventoryInStock)
            .html(wpbingo.strings.inStock);
          $(selectors.quantityElements, this.$container).removeClass(this.classes.hide);
          $(selectors.shopifyPaymentButton, this.$container).removeClass(this.classes.hide);
        } else {
          $(selectors.addToCart, this.$container).addClass("disabled").prop("disabled", true);
          $(selectors.addToCartText, this.$container).find(".btn_text").text(translations.soldOut);
          $(selectors.productAvailableText)
            .removeClass(this.classes.productInventoryInStock)
            .addClass(this.classes.productInventoryOutStock)
            .html(wpbingo.strings.outStock);
          $(selectors.quantityElements, this.$container).addClass(this.classes.hide);
          $(selectors.shopifyPaymentButton, this.$container).addClass(this.classes.hide);
        }
        // $(selectors.productPrice, this.$container).html(wpbingo.Currency.formatMoney(variant.price, moneyFormat)).removeClass(this.classes.hide);
        // $(selectors.productPrice, this.$container).attr("content", (Number(variant.price) / 100).toFixed(2));

        /* Update on seasonal subscription page starts */
        if ($(".subscription_price_disclaimer .price").length) {
          const quarterlyPrices = {
            56710746046790: "26.25",
            56710746079558: "42.50",
            56710746112326: "57.50",
            56710746145094: "69.95",
          };
          const yearlyPrices = {
            56607265685830: "105.00",
            56607265784134: "170.00",
            56607265882438: "230.00",
            56607265980742: "279.80",
          };
          const subType = $('.variants-wrapper[data-variant-label="subscription-type"] .single-option-selector input:checked').val() || "";
          let quarterlyPrice;
          let yearlyPrice;
          let totalSeasonalPrice;
          let perUnitPrice;
          let priceDiscount;
          if (subType == "Quarterly Subscription") {
            quarterlyPrice = Number(variant.price);

            totalSeasonalPrice = quarterlyPrice * 4;

            perUnitPrice = quarterlyPrice;

            // Get yearly price for the lawn size equivalent
            yearlyPrice = Number(yearlyPrices[variant.id]) * 100;
            priceDiscount = yearlyPrice * 0.1;
            yearlyPrice = yearlyPrice - priceDiscount;
          } else {
            yearlyPrice = Number(variant.price);
            priceDiscount = yearlyPrice * 0.1;
            yearlyPrice = yearlyPrice - priceDiscount;

            totalSeasonalPrice = yearlyPrice;

            quarterlyPrice = Number(quarterlyPrices[variant.id]) * 100;

            perUnitPrice = yearlyPrice;
          }

          // Update the main price element
          $(selectors.productPrice).html(wpbingo.Currency.formatMoney(perUnitPrice, moneyFormat)).removeClass(this.classes.hide);

          // Update the content within the price element
          $(selectors.productPrice).attr("content", (perUnitPrice / 100).toFixed(2));

          // Disclaimer price
          $(".subscription_price_disclaimer .price").html(wpbingo.Currency.formatMoney(totalSeasonalPrice, moneyFormat));

          // Quarterly subscription accordion element
          $('.subscription-card[data-subscription-type="quarterly-subscription"] .subscription-card__price .price').html(
            wpbingo.Currency.formatMoney(quarterlyPrice, moneyFormat),
          );

          // Annual subscription accordion element
          $('.subscription-card[data-subscription-type="yearly-subscription"] .subscription-card__price .price').html(
            wpbingo.Currency.formatMoney(yearlyPrice, moneyFormat),
          );

          // Add to cart button price
          $(selectors.addToCart, this.$container).find(".price_text").html(wpbingo.Currency.formatMoney(perUnitPrice, moneyFormat));
        } else {
          $(selectors.productPrice, this.$container).html(wpbingo.Currency.formatMoney(variant.price, moneyFormat)).removeClass(this.classes.hide);
          $(selectors.productPrice, this.$container).attr("content", (Number(variant.price) / 100).toFixed(2));
          // Add to cart button price
          let currentQtyInputVal = Number($(".js-qty-number").val());
          let currentPrice = Number(variant.price) * currentQtyInputVal;
          $(selectors.addToCart, this.$container).find(".price_text").html(wpbingo.Currency.formatMoney(currentPrice, moneyFormat));
        }
        /* Update on seasonal subscription page ends */

        if (variant.compare_at_price > variant.price) {
          $(selectors.comparePrice, this.$container).html(wpbingo.Currency.formatMoney(variant.compare_at_price, moneyFormat));
          $(selectors.comparePriceWrapper, this.$container).removeClass(this.classes.hide);
          $(selectors.productPrice, this.$container).addClass("on-sale");
          $(selectors.comparePriceWrapper, this.$container).attr("aria-hidden", "false");
          $(selectors.comparePriceA11y, this.$container).attr("aria-hidden", "false");
        } else {
          $(selectors.comparePriceWrapper, this.$container).addClass(this.classes.hide).attr("aria-hidden", "true");
          $(selectors.productPrice, this.$container).removeClass("on-sale");
          $(selectors.comparePrice, this.$container).html("");
          $(selectors.comparePriceA11y, this.$container).attr("aria-hidden", "true");
        }

        if (variant.unit_price) {
          var $unitPrice = $(selectors.unitPrice, this.$container);
          var $unitPriceBaseUnit = $(selectors.unitPriceBaseUnit, this.$container);
          $unitPrice.html(wpbingo.Currency.formatMoney(variant.unit_price, moneyFormat));
          $unitPriceBaseUnit.html(this.getBaseUnit(variant));
          $(selectors.priceContainer, this.$container).addClass(this.classes.priceContainerUnitAvailable);
        }
        $(selectors.SKU).html(variant.sku != "" ? variant.sku : "N/A");
      } else {
        $(selectors.addToCart, this.$container).addClass("disabled").prop("disabled", true);
        $(selectors.addToCartText, this.$container).find(".btn_text").text(translations.unavailable);
        $(selectors.quantityElements, this.$container).addClass(this.classes.hide);
        $(selectors.shopifyPaymentButton, this.$container).addClass(this.classes.hide);
        $(selectors.priceContainer, this.$container).addClass(this.classes.hide);
        $(selectors.productAvailable, this.$container).addClass(this.classes.hide);
        $(selectors.productPrice, this.$container).attr("aria-hidden", "true");
        $(selectors.priceA11y, this.$container).attr("aria-hidden", "true");
        $(selectors.comparePriceWrapper, this.$container).attr("aria-hidden", "true");
        $(selectors.comparePriceA11y, this.$container).attr("aria-hidden", "true");
      }
    },

    onUnload: function () {
      this.$container.off(this.settings.namespace);
      wpbingo.ProductModel.removeSectionModels(this.settings.sectionId);
      if (this.isStackedLayout) {
        if ($(window).width() > 991) {
          this.destroyMediaCarousel();
        }
      }
    },
    count_view_product: function () {
      if ($(".product-count-view").length > 0) {
        var id_product = $(".product-count-view").data("id_product");
        var min = $(".product-count-view").data("min") ? $(".product-count-view").data("min") : 30;
        var max = $(".product-count-view").data("max") ? $(".product-count-view").data("max") : 40;
        var timeout = $(".product-count-view").data("timeout") ? $(".product-count-view").data("timeout") : 10000;
        var auto = Math.round(Math.random() * (max - min)) + min;
        $("span", ".product-count-view").html(auto);
        setTimeout(function random() {
          var auto = Math.round(Math.random() * (max - min)) + min;
          $("span", ".product-count-view").html(auto);
          setTimeout(random, timeout);
        }, timeout);
      }
    },
    count_sale_product: function () {
      if ($(".product-count-sale").length > 0) {
        var id_product = $(".product-count-sale").data("id_product");
        var min = $(".product-count-sale").data("min") ? $(".product-count-sale").data("min") : 30;
        var max = $(".product-count-sale").data("max") ? $(".product-count-sale").data("max") : 40;
        var time_min = $(".product-count-sale").data("time_min") ? $(".product-count-sale").data("time_min") : 30;
        var time_max = $(".product-count-sale").data("time_max") ? $(".product-count-sale").data("time_max") : 40;
        var cookieValue = wpbingo.getCookie("product_" + id_product);
        var cookieTime = wpbingo.getCookie("time_" + id_product);
        if (cookieValue && cookieTime) {
          $("span.count", ".product-count-sale").html(cookieValue);
          $("span.time", ".product-count-sale").html(cookieTime);
        } else {
          var rand = Math.round(Math.random() * (max - min)) + min;
          var time = Math.round(Math.random() * (time_max - time_min)) + time_min;
          wpbingo.setCookie("product_" + id_product, rand, { expires: 24 * 60 * 60 * 1000 });
          wpbingo.setCookie("time_" + id_product, time, { expires: 24 * 60 * 60 * 1000 });
          $("span.count", ".product-count-sale").html(rand);
          $("span.time", ".product-count-sale").html(time);
        }
      }
    },
    percent_sale_product: function () {
      setTimeout(function () {
        var percent = $(".js-product-avaiable #variant-inventory_percent.show").data("percent");
        $(".js-product-avaiable #variant-inventory_percent .percent").css("--progress-bar-width", percent);
      }, 500);
    },
    delivery_return: function () {
      if ($(".product-single .delivery_return").length > 0) {
        var $element = $(".product-single .delivery_return");
        $(".delivery_return-title", $element).on("click", function () {
          if (!$(".delivery_return-content", $element).hasClass("active")) {
            $(".delivery_return-content", $element).addClass("active");
            setTimeout(function () {
              $(".content-shipping", $element).addClass("active");
            }, 300);
          }
        });
        $(".delivery_return-close", $element).on("click", function () {
          if ($(".delivery_return-content", $element).hasClass("active")) {
            $(".content-shipping", $element).removeClass("active");
            setTimeout(function () {
              $(".delivery_return-content", $element).removeClass("active");
            }, 300);
          }
        });
      }
    },
    ask_a_question: function () {
      if ($(".product-single .product-ask_a_question").length > 0) {
        $(".product-ask_a_question .open-ask_a_question").on("click", function () {
          if ($(".product-ask_a_question .ask_a_question-form").hasClass("active")) {
            $(".product-ask_a_question .ask_a_question-form").removeClass("active");
            $(".product-ask_a_question .ask_a_question-form .content-form").removeClass("active");
          } else {
            $(".product-ask_a_question .ask_a_question-form").addClass("active");
            setTimeout(function () {
              $(".product-ask_a_question .ask_a_question-form .content-form").addClass("active");
            }, 300);
          }
        });
        $(".product-ask_a_question .close-ask_a_question-form").on("click", function () {
          if ($(".product-ask_a_question .ask_a_question-form").hasClass("active")) {
            $(".product-ask_a_question .ask_a_question-form .content-form").removeClass("active");
            setTimeout(function () {
              $(".product-ask_a_question .ask_a_question-form").removeClass("active");
            }, 300);
          }
        });
        setTimeout(function () {
          $(".product-ask_a_question .alert").remove();
        }, 2000);
      }
    },
    back_in_stock: function () {
      if ($(".product-single .product-back_in_stock").length > 0) {
        $(".product-back_in_stock .open-back_in_stock").on("click", function () {
          if ($(".product-back_in_stock .back_in_stock-form").hasClass("active")) {
            $(".product-back_in_stock .back_in_stock-form").removeClass("active");
            $(".product-back_in_stock .back_in_stock-form .content-form").removeClass("active");
          } else {
            $(".product-back_in_stock .back_in_stock-form").addClass("active");
            setTimeout(function () {
              $(".product-back_in_stock .back_in_stock-form .content-form").addClass("active");
            }, 300);
          }
        });
        $(".product-back_in_stock .close-back_in_stock-form").on("click", function () {
          if ($(".product-back_in_stock .back_in_stock-form").hasClass("active")) {
            $(".product-back_in_stock .back_in_stock-form .content-form").removeClass("active");
            setTimeout(function () {
              $(".product-back_in_stock .back_in_stock-form").removeClass("active");
            }, 300);
          }
        });
        setTimeout(function () {
          $(".product-back_in_stock .alert").remove();
        }, 2000);
      }
    },
    single_product_share: function () {
      if ($(".product-single .product_share").length > 0) {
        var $element = $(".product-single .product_share");
        $(".product_share_label", $element).on("click", function () {
          if (!$(".product_share-content", $element).hasClass("active")) {
            $(".product_share-content", $element).addClass("active");
            setTimeout(function () {
              $(".content-product_share", $element).addClass("active");
            }, 300);
          }
        });
        $(".product_share-close", $element).on("click", function () {
          if ($(".product_share-content", $element).hasClass("active")) {
            $(".content-product_share", $element).removeClass("active");
            setTimeout(function () {
              $(".product_share-content", $element).removeClass("active");
            }, 300);
          }
        });
        $(".product_share-copy button", $element).click(function () {
          var copyText = $(".product_share-copy .url_share", $element).attr("value");
          var $text = $(".product_share-copy", $element).data("text");
          var $temp = $("<input>");
          $("body").append($temp);
          $temp.val(copyText).select();
          document.execCommand("copy");
          $temp.remove();
          var notificationTag = $("div.copy-notification");
          if (notificationTag.length == 0) {
            notificationTag = $("<div/>", { class: "copy-notification", text: $text });
            $("body").append(notificationTag);
            notificationTag.fadeIn("slow", function () {
              setTimeout(function () {
                notificationTag.fadeOut("slow", function () {
                  notificationTag.remove();
                });
              }, 1000);
            });
          }
        });
      }
    },
    gallery_cursor: function () {
      $(".bwp-single-image .product-media__wrapper.product-media__wrapper--image").mouseenter(function () {
        $(".gallery-cursor", $(this)).addClass("show");
      });
      $(".bwp-single-image .product-media__wrapper.product-media__wrapper--image").mousemove(function (event) {
        var offset = $(this).offset();
        var relX = event.pageX - offset.left - 25;
        var relY = event.pageY - offset.top - 25;
        $(".gallery-cursor", $(this)).css({ top: relY + "px", left: relX + "px" });
      });
      $(".bwp-single-image .product-media__wrapper.product-media__wrapper--image").mouseleave(function (event) {
        $(".gallery-cursor", $(this)).removeClass("show");
      });
    },
    sticky_gird: function () {
      if ($(window).width() > 992 && $(".product-single.gird-sticky").length > 0) {
        var $element = $(".product-single.gird-sticky");
        var eventElemArray = [];
        var _count = 0;
        var _countFix = 0;
        var $image_array = $(".js-product-media-group .js-product-media-item", $element);
        $(".js-product-thumbnails a", $element).on("click", function () {
          var $thumb = $(this).data("media-id"),
            $image = $(".js-product-media-group .js-product-media[data-media-id=" + $thumb + "]", $element);
          $("html, body").animate({ scrollTop: $image.offset().top }, "300");
          $image.css({ "padding-top": "15px" });
          $(this).addClass("slick-current");
        });
        $(window).on("load scroll resize", function () {
          eventElemArray = [];
          _count = 0;
          $image_array.each(function (i, pager) {
            eventElemArray.push($(pager).offset().top);
          });
          for (var _i = 0; _i < eventElemArray.length; _i++) {
            if ($(window).scrollTop() + $(window).height() * 0.5 > eventElemArray[_i]) {
              _count++;
            }
          }
          if (_count !== _countFix) {
            _countFix = _count;
            $(".js-product-thumbnails .product-single__thumbnail-wrapper", $element).removeClass("slick-current");
            $(".js-product-thumbnails .product-single__thumbnail-wrapper", $element)
              .eq(_count - 1)
              .addClass("slick-current");
          }
        });
        // sticky thumb
        var $content = $(".js-product-single-media", $element);
        var thumb_left = $(".js-product-thumbnails", $element).offset.left;
        var thumb_width = $(".js-product-thumbnails", $element).width() + "px";
        var thumb_ToTop = $(".js-product-thumbnails", $element).offset().top;
        if ($content.height() > $(".js-product-thumbnails", $element).height()) {
          $(window).scroll(function () {
            var windowToTop = $(window).scrollTop();
            var thumb_height = $(".js-product-thumbnails", $element).height() + "px";
            var stopsticky = $content.height() + $content.offset().top - windowToTop;
            if (windowToTop + 10 > thumb_ToTop) {
              $(".js-product-thumbnails", $element).css({
                position: "fixed",
                top: "15px",
                left: thumb_left,
                width: thumb_width,
                height: thumb_height,
              });
            } else {
              $(".js-product-thumbnails", $element).removeAttr("style");
              $(".js-product-media-group .js-product-media", $element).removeAttr("style");
            }
            if (stopsticky < $(".js-product-thumbnails", $element).height()) {
              $(".js-product-thumbnails", $element).css({
                position: "absolute",
                top: $content.height() - $(".js-product-thumbnails", $element).height() + "px",
                left: thumb_left,
                width: thumb_width,
                height: thumb_height,
              });
            }
          });
        }
        // sticky info
        var info_image = $(".js-product-media-item", $content).height() * 2;
        var info_left = $(".product-single__metas", $element).offset.left;
        var info_width = $(".product-single__metas", $element).width() + "px";
        var info_ToTop = $(".product-single__metas", $element).offset().top;
        if ($content.height() > $(".product-single__metas", $element).height() + info_image) {
          $(window).scroll(function () {
            var windowToTop = $(window).scrollTop();
            var info_height = $(".product-single__metas", $element).height() + "px";
            var stopsticky = $content.height() + $content.offset().top - windowToTop;
            if (windowToTop + 10 > info_ToTop) {
              $(".product-single__metas", $element).css({
                position: "fixed",
                top: "15px",
                left: info_left,
                width: info_width,
                height: info_height,
              });
            } else {
              $(".product-single__metas", $element).removeAttr("style");
            }
            if (stopsticky < $(".product-single__metas", $element).height() + info_image) {
              $(".product-single__metas", $element).css({
                position: "absolute",
                top: $content.height() - $(".product-single__metas", $element).height() - info_image + "px",
                left: info_left,
                width: info_width,
                height: info_height,
              });
            }
          });
        }
      }
    },
    sticky_sidebar: function () {
      if ($(window).width() < 1199 && $(".product-single .bwp-single-sidebar").length > 0) {
        var $element = $(".product-single .bwp-single-sidebar");
        $(".product-single .toggle-sidebar").on("click", function () {
          if ($element.hasClass("show")) {
            $element.removeClass("show");
          } else {
            $element.addClass("show");
          }
        });
      }
    },
    image_360: function () {
      if ($(".product-single .bwp-image-360").length > 0) {
        $(".product-single .bwp-image-360")
          .TreeSixtyImageRotate({
            totalFrames: $(".product-single .bwp-image-360").data("count"),
            endFrame: $(".product-single .bwp-image-360").data("count"),
          })
          .initTreeSixty();
      }
    },
    tab_information: function () {
      if (!$(".template-product .product-more-info").length) return;

      var $parent = $(".template-product .product-more-info");
      var $navLinks = $(".more-info-tabs__nav-link", $parent);
      var $panes = $(".more-info-tabs__content .tab-pane", $parent);

      function initTabs() {
        // Clean previous state
        $navLinks.off("click");
        $panes.stop(true, true).removeAttr("style").removeClass("show");
        $navLinks.removeClass("active");

        if ($(window).width() > 991) {
          // Desktop tabs
          $navLinks.on("click", function () {
            var id = $(this).data("id");

            $navLinks.removeClass("active");
            $panes.removeClass("show");

            $(this).addClass("active");
            $("#" + id, $parent).addClass("show");
          });

          // Ensure at least one tab is visible
          $navLinks.first().addClass("active");
          $("#" + $navLinks.first().data("id"), $parent).addClass("show");
        } else {
          // Mobile accordion
          $navLinks.on("click", function () {
            var id = $(this).data("id");

            $("body,html").animate(
              {
                scrollTop: $(".more-info-tabs__content").offset().top - 50,
              },
              600,
            );

            if ($(this).hasClass("active")) {
              $("#" + id, $parent).slideUp();
              $navLinks.removeClass("active");
            } else {
              $panes.slideUp();
              $("#" + id, $parent).slideDown();
              $navLinks.removeClass("active");
              $(this).addClass("active");
            }
          });
        }
      }

      // Initial run
      // initTabs();

      // Re-init on orientation change / resize
      // $(window).on("resize orientationchange", _.debounce(initTabs, 150));

      var isDesktop = $(window).width() > 991;

      initTabs();

      $(window).on(
        "resize orientationchange",
        _.debounce(function () {
          var nowDesktop = $(window).width() > 991;

          if (nowDesktop !== isDesktop) {
            isDesktop = nowDesktop;
            initTabs();
          }
        }, 150),
      );
    },
  });
  return Product;
})();

// HEADER SECTION
wpbingo.HeaderSection = (function () {
  var selectors = {
    disclosureLocale: "[data-disclosure-locale]",
    disclosureCurrency: "[data-disclosure-currency]",
    searchOptions: ".js-header-search-options",
    searchMobileToggle: ".js-header-search-toggle",
    menuMobileToggle: ".js-menu-mobile",
    menuMobileChildToggle: ".js-mm-nav-item",
  };

  const $openButton = $(".button-menu .js-menu-mobile");
  const $mobileNav = $(".menu-mobile__nav");

  $openButton.attr({ "aria-expanded": "false", "aria-controls": "mobile-navigation" });
  $mobileNav.attr({ id: "mobile-navigation", "aria-hidden": "true" });

  function Header(container) {
    this.$container = $(container);
    this.cache = {};
    this.cacheSelectors();
    var $body = $("body");
    if (this.cache.$localeDisclosure.length) {
      this.localeDisclosure = new wpbingo.Disclosure(this.cache.$localeDisclosure);
    }

    if (this.cache.$currencyDisclosure.length) {
      this.currencyDisclosure = new wpbingo.Disclosure(this.cache.$currencyDisclosure);
    }

    this.cache.$searchOptions.on("click", function (evt) {
      evt.preventDefault();
      var $this = $(this),
        $form = $this.closest("form");
      $form.find(".js-header-search-options").removeClass("active");
      $this.addClass("active");
      $form.find(".dropdown-toggle").text($this.text());
      $form.find(".js-search-type").val($this.data("type"));
    });

    this.cache.$searchMobileToggle.on("click", function (evt) {
      evt.preventDefault();
      $body.toggleClass("modal-search--open");
    });

    let lastInputWasKeyboard = false;

    $(document)
      .on("keydown", function (e) {
        if (e.key === "Tab") {
          lastInputWasKeyboard = true;
        }
      })
      .on("pointerdown touchstart mousedown", function () {
        lastInputWasKeyboard = false;
      });

    this.cache.$menuMobileToggle.on("click", function (evt) {
      evt.preventDefault();

      $body.toggleClass("menu-mobile--open");

      const isOpen = $body.hasClass("menu-mobile--open");

      $openButton.attr("aria-expanded", isOpen);
      $mobileNav.attr("aria-hidden", !isOpen);

      if (isOpen) {
        var $mobileMenuclose = $(".menu-mobile__inner .js-menu-mobile");

        if ($mobileMenuclose.length) {
          setTimeout(function () {
            if (lastInputWasKeyboard) {
              $mobileMenuclose.trigger("focus");
            }
          }, 500);
        } else {
          setTimeout(function () {
            if (lastInputWasKeyboard) {
              $(".menu-mobile__nav-item:first-child a").trigger("focus");
            }
          }, 500);
        }
      } else {
        if (lastInputWasKeyboard) {
          $openButton.trigger("focus");
        }
      }
    });

    /*$(".menu-mobile__overlay").on("click", function (evt) {
      evt.preventDefault();
      $body.removeClass("menu-mobile--open");
      $(".button-menu .js-menu-mobile").trigger("focus");
    });*/

    $(".menu-mobile__overlay").on("click", function (evt) {
      evt.preventDefault();

      $body.removeClass("menu-mobile--open");

      $openButton.attr("aria-expanded", "false");

      if (lastInputWasKeyboard) {
        $openButton.trigger("focus");
      }

      $mobileNav.attr("aria-hidden", "true");
    });

    this.cache.$menuMobileChildToggle.on("click", function (evt) {
      evt.preventDefault();
      var $this = $(this);
      if ($this.hasClass("mm-nav__prev")) {
        $this.closest(".active--hidden").removeClass("active--hidden");
      } else {
        $this.parents(".mm-nav__links").addClass("active--hidden");
      }
      $this.closest(".menu-mobile__nav-item").toggleClass("active");
    });
  }

  Header.prototype = _.assignIn({}, Header.prototype, {
    cacheSelectors: function () {
      this.cache = {
        $localeDisclosure: this.$container.find(selectors.disclosureLocale),
        $currencyDisclosure: this.$container.find(selectors.disclosureCurrency),
        $searchOptions: this.$container.find(selectors.searchOptions),
        $searchMobileToggle: this.$container.find(selectors.searchMobileToggle),
        $menuMobileToggle: this.$container.find(selectors.menuMobileToggle),
        $menuMobileChildToggle: this.$container.find(selectors.menuMobileChildToggle),
      };
    },

    onUnload: function () {
      if (this.cache.$localeDisclosure.length) {
        this.localeDisclosure.unload();
      }

      if (this.cache.$currencyDisclosure.length) {
        this.currencyDisclosure.unload();
      }
    },
  });

  return Header;
})();

wpbingo.Search = (function () {
  var selectors = {
    search: "[data-search]",
    searchPagination: ".search-pagination a",
  };

  function Search(container) {
    var ajaxCartSearch = function () {
      if (typeof ajaxCart != "undefined") {
        ajaxCart.init({
          formSelector: ".search-results [data-product-form]",
        });
      }
    };

    var searchResultData = function (container, url) {
      $.get(url, function (data) {
        container.html(data);
        ajaxCartSearch();
      });
    };

    var getSearchResult = function (searchs) {
      searchs.each(function () {
        var $this = $(this);
        $.get($this.data("url"), function (data) {
          $this.html(data);
          ajaxCartSearch();
        });
      });
    };

    this.$container = $(container);
    this.cache = {};
    this.cacheSelectors();

    if (this.cache.$search.length) {
      getSearchResult(this.cache.$search);
    }

    this.$container.on("click", selectors.searchPagination, function (e) {
      e.preventDefault();
      var $searchContainer = $(this).parents(selectors.search);
      var searchURL = $(this).attr("href");
      searchResultData($searchContainer, searchURL);
    });
  }

  Search.prototype = _.assignIn({}, Search.prototype, {
    cacheSelectors: function () {
      this.cache = {
        $search: this.$container.find(selectors.search),
      };
    },
  });

  return Search;
})();

if (typeof ShopifyAPI === "undefined") {
  ShopifyAPI = {};
}

ShopifyAPI.attributeToString = function (attribute) {
  if (typeof attribute !== "string") {
    attribute += "";
    if (attribute === "undefined") {
      attribute = "";
    }
  }
  return jQuery.trim(attribute);
};

ShopifyAPI.updateCartNote = function (note, callback) {
  var params = {
    type: "POST",
    url: "/cart/update.js",
    data: "note=" + ShopifyAPI.attributeToString(note),
    dataType: "json",
    success: function (cart) {
      if (typeof callback === "function") {
        callback(cart);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
  };
  jQuery.ajax(params);
};

ShopifyAPI.applyDiscount = function () {
  const discountCodeVal = document.querySelector(".cart-table .discount_code_input").value.trim();

  if (!discountCodeVal) return;

  window.location.href = `${window.location.origin}/discount/${encodeURIComponent(discountCodeVal)}?redirect=/cart`;
};

ShopifyAPI.clearDiscount = function () {
  ShopifyAPI.updateCartAttribute("discount_code", "", function () {
    setTimeout(() => {
      ShopifyAPI.goToCheckout();
    }, 1000);
  });
};

ShopifyAPI.goToCheckout = function () {
  const discountCodeInput = document.querySelector(".cart-table .discount_code_input");

  if (!discountCodeInput) {
    window.location.href = "/checkout";
    return;
  }

  const discountCodeVal = discountCodeInput.value.trim();

  if (discountCodeInput.hasAttribute("readonly") && discountCodeVal) {
    window.location.href = `${window.location.origin}/discount/${encodeURIComponent(discountCodeVal)}?redirect=/checkout`;
  } else {
    window.location.href = "/checkout";
  }
};

ShopifyAPI.updateCartAttribute = function (key, value, callback) {
  var data = {};
  data["attributes[" + key + "]"] = ShopifyAPI.attributeToString(value);

  var params = {
    type: "POST",
    url: "/cart/update.js",
    data: data,
    dataType: "json",
    success: function (cart) {
      if (typeof callback === "function") {
        callback(cart);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
  };

  jQuery.ajax(params);
};

ShopifyAPI.onError = function (XMLHttpRequest) {
  var data = eval("(" + XMLHttpRequest.responseText + ")");
  if (data.message) {
    alert(data.message + "(" + data.status + "): " + data.description);
  }
};

ShopifyAPI.addItemFromForm = function (form, callback, errorCallback) {
  var formData = new FormData(form);
  // console.log(formData);
  var params = {
    type: "POST",
    url: "/cart/add.js",
    data: formData,
    processData: false,
    contentType: false,
    dataType: "json",
    success: function (line_item) {
      if (typeof callback === "function") {
        callback(line_item, form);
        if ($(".product-single .content-variant_inventory").length > 0) {
          setTimeout(function () {
            $(".product-single .content-variant_inventory").load(window.location.href + ".content-variant_inventory .js-product-avaiable");
          }, 100);
        }
      } else {
        ShopifyAPI.onItemAdded(line_item, form);
        if ($(".product-single .content-variant_inventory").length > 0) {
          setTimeout(function () {
            $(".product-single .content-variant_inventory").load(window.location.href + ".content-variant_inventory .js-product-avaiable");
          }, 100);
        }
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      if (typeof errorCallback === "function") {
        errorCallback(XMLHttpRequest, textStatus);
      } else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    },
  };
  jQuery.ajax(params);
};

ShopifyAPI.getCart = function (callback, added) {
  jQuery.getJSON("/cart.js", function (cart) {
    if (typeof callback === "function") {
      callback(cart, added);
    }
  });
};

ShopifyAPI.changeItem = function (line, quantity, callback, modal) {
  jQuery.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: {
      line: line,
      quantity: quantity,
    },
    dataType: "json",
    success: function (cart) {
      if (typeof callback === "function") {
        callback(cart);
      }
      if (modal) {
        var moneyFormat = "${{amount}}";
        if (wpbingo.strings.moneyFormat !== undefined) {
          moneyFormat = wpbingo.strings.moneyFormat;
        }
        var id = $("#form-modal-addtocart input[data-modal-variant]").val();
        for (var j in cart.items) {
          if (id == cart.items[j].variant_id) {
            var price = cart.items[j].final_line_price;
            var price_discount = cart.items[j].original_line_price;
          }
        }
        $("#form-modal-addtocart .modalcart__line_price .price").html(wpbingo.Currency.formatMoney(price, moneyFormat));
        if (cart.items[j].discounts.length > 0) {
          $("#form-modal-addtocart .modalcart__line_price .price_discount").html(wpbingo.Currency.formatMoney(price_discount, moneyFormat));
          for (var i in cart.items[j].discounts) {
            $(".js-cart-modal .discount").text(cart.items[j].discounts[i].title);
          }
        } else {
          $("#form-modal-addtocart .modalcart__line_price .price_discount").empty();
          $(".js-cart-modal .discount").empty();
        }
        $("#form-modal-addtocart .cart-modal__middle").removeClass("load_modal");
      }
    },
    error: function (XMLHttpRequest) {
      // Handle Shopify quantity / availability error (422)
      if (XMLHttpRequest.status === 422) {
        var response = null;

        try {
          response = JSON.parse(XMLHttpRequest.responseText);
        } catch (e) {}

        // Prevent duplicate alerts (Shopify also alerts internally)
        if (!XMLHttpRequest._handled422) {
          XMLHttpRequest._handled422 = true;

          if (response && response.message) {
            alert(response.message);
          }
        }

        // Re-sync cart so UI does not freeze
        jQuery.getJSON("/cart.js", function (cart) {
          if (typeof callback === "function") {
            callback(cart);
          }

          jQuery('#cart-form .item-cart[data-line="' + line + '"]').removeClass("is-loading");
        });

        // IMPORTANT: do NOT call ShopifyAPI.onError for 422
        return;
      }

      // Only for non-422 errors
      ShopifyAPI.onError(XMLHttpRequest);
    },
  });
};

var ajaxCart = (function (module, $) {
  "use strict";

  var init, loadCart;
  var settings, isUpdating, $body;
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer;
  var initializeEvents,
    updateCountPrice,
    formOverride,
    itemAddedCallback,
    itemErrorCallback,
    cartModalAdded,
    updateModalRecommendations,
    cartUpdateCallback,
    formatSubscriptionRenewalDate,
    updateCartSubscriptionInfo,
    buildCart,
    cartCallback,
    adjustCart,
    adjustCartCallback,
    validateQty;

  var cartTemplate;
  var cartModalHeaderTemplate;
  var currentCart = null;

  var currentDate = new Date();
  var currentMonth = currentDate.getMonth() + 1;

  var renewalDates = {
    1: { quarterly: { current: "1 April", next: "1 May" }, yearly: { current: "1 December", next: "1 March" } },
    2: { quarterly: { current: "1 May", next: "1 June" }, yearly: { current: "1 December", next: "1 March" } },
    3: { quarterly: { current: "1 June", next: "1 July" }, yearly: { current: "1 March", next: "1 June" } },
    4: { quarterly: { current: "1 July", next: "1 August" }, yearly: { current: "1 March", next: "1 June" } },
    5: { quarterly: { current: "1 August", next: "1 September" }, yearly: { current: "1 March", next: "1 June" } },
    6: { quarterly: { current: "1 September", next: "1 October" }, yearly: { current: "1 June", next: "1 September" } },
    7: { quarterly: { current: "1 October", next: "1 November" }, yearly: { current: "1 June", next: "1 September" } },
    8: { quarterly: { current: "1 November", next: "1 December" }, yearly: { current: "1 June", next: "1 September" } },
    9: { quarterly: { current: "1 December", next: "1 January" }, yearly: { current: "1 September", next: "1 December" } },
    10: { quarterly: { current: "1 January", next: "1 February" }, yearly: { current: "1 September", next: "1 December" } },
    11: { quarterly: { current: "1 February", next: "1 March" }, yearly: { current: "1 September", next: "1 December" } },
    12: { quarterly: { current: "1 March", next: "1 April" }, yearly: { current: "1 December", next: "1 March" } },
  };

  const tyl_product = 15549548462406; // Transform your lawn
  const ss_product = 15563267309894; // Seasonal Subscription

  init = function (options) {
    settings = {
      formSelector: "[data-product-form]",
      cartContainer: "[data-cart-container]",
      addToCartSelector: 'button[type="submit"]',
      cartCountSelector: "[data-cart-count]",
      cartCostSelector: "[data-cart-cost]",
      cartRemoveSelector: "[data-cart-remove]",
      headerCartSelector: ".js-header-cart",
      cartModalSelector: ".js-cart-modal",
      cartModalCloseSelector: ".js-cart-modal-close",
      moneyFormat: "${{amount}}",
      disableAjaxCart: false,
      cartTemplate: "#ajaxcart-template",
      cartModalHeaderTemplate: "#ajaxcart-header-template",
    };

    if (wpbingo.strings.moneyFormat !== undefined) {
      settings.moneyFormat = wpbingo.strings.moneyFormat;
    }

    $.extend(settings, options);

    $formContainer = $(settings.formSelector);
    $cartContainer = $(settings.cartContainer);
    $addToCart = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector = $(settings.cartCostSelector);
    $body = $("body");
    isUpdating = false;

    var cartTemplateSource = $(settings.cartTemplate).html();
    var cartModalHeaderSource = $(settings.cartModalHeaderTemplate).html();

    cartTemplate = cartTemplateSource ? Handlebars.compile(cartTemplateSource) : null;
    cartModalHeaderTemplate = cartModalHeaderSource ? Handlebars.compile(cartModalHeaderSource) : null;

    initializeEvents();

    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    adjustCart();
  };

  initializeEvents = function () {
    $body.on("click", settings.cartModalCloseSelector, function () {
      $(".js-cart-modal .cart-modal__inner").removeClass("show");

      setTimeout(function () {
        $(settings.cartModalSelector).fadeOut(400, function () {
          $(this).remove();
        });
      }, 400);
    });

    $body.on("click", settings.headerCartSelector, function (e) {
      if (wpbingo.settings.cartType == "modal" && $(window).width() > 767 && !$("body").hasClass("template-cart")) {
        e.preventDefault();
      }
    });

    $body.on("click", settings.cartRemoveSelector, function (e) {
      e.preventDefault();

      if (isUpdating) {
        return;
      }

      var line = $(this).data("line");

      if (line) {
        getCartRowsByLine(line).addClass("is-loading");
        isUpdating = true;
        ShopifyAPI.changeItem(line, 0, adjustCartCallback);
      }
    });

    $body.on("click", ".ajaxcart__info .save-ajaxcart__note", function () {
      ShopifyAPI.updateCartNote($(".ajaxcart__note-input").val(), function () {});
    });

    $body.on("click", ".ajaxcart__info .save-discount_code_input", function () {
      wpbingo.setCookie("wpbingo_discount", $(".discount_code_input").val(), 1);
    });

    $body.on("change", "#form-modal-addtocart .modalcart__quantity input", function () {
      updateModalQuantity($(this).val());
    });

    $body.on("click", "#form-modal-addtocart .modalcart__quantity .ajaxcart__qty-adjust", function () {
      if (isUpdating) {
        return;
      }

      var $el = $(this);
      var $qtySelector = $el.siblings(".ajaxcart__qty-num");
      var qty = validateQty(parseInt($qtySelector.val().replace(/\D/g, "")));

      if ($el.hasClass("ajaxcart__qty--plus") || $el.hasClass("wpbingo-qty__adjust--plus")) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      $qtySelector.val(qty);
      updateModalQuantity(qty);
    });
  };

  loadCart = function () {
    if ($(".js-drawer").length > 0 || $cartContainer.length > 0) {
      $body.addClass("ajaxcart--is-loading");
    }

    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector.length) {
      $cartCountSelector.html(cart.item_count);
    }

    if ($(".js-drawer").length > 0 || $cartContainer.length > 0) {
      if ($cartCostSelector.length) {
        $cartCostSelector.html(wpbingo.Currency.formatMoney(cart.total_price, settings.moneyFormat));
      }

      $(".cart-modal-totalprice span").html(wpbingo.Currency.formatMoney(cart.total_price, settings.moneyFormat));
      $(".cart-modal-totalcount span.count").html(cart.item_count);
    }
  };

  formOverride = function () {
    $body.on("submit", settings.formSelector, function (evt) {
      evt.preventDefault();

      var $submitButton = $(".btn--add-to-cart", this);

      $submitButton.attr("disabled", "disabled").prepend('<span class="spinner-border spinner-border-sm"></span>');
      $submitButton.removeClass("is-added").addClass("is-adding");
      $(".ajaxcart-toast").toast("hide");

      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
  };

  itemAddedCallback = function (lineItem) {
    $("form .btn--add-to-cart").removeAttr("disabled").find(".spinner-border").remove();
    $("form .btn--add-to-cart").removeClass("is-adding").addClass("is-added");

    if (wpbingo.settings.cartType == "modal") {
      cartModalAdded(lineItem);
    }

    ShopifyAPI.getCart(function (cart) {
      cartUpdateCallback(cart, true);
    });

    announceCartAddition(lineItem);
  };

  itemErrorCallback = function (XMLHttpRequest) {
    var data = null;

    try {
      if (XMLHttpRequest && XMLHttpRequest.responseText) {
        data = JSON.parse(XMLHttpRequest.responseText);
      }
    } catch (e) {
      console.error("Failed to parse response:", e);
    }

    $addToCart.removeAttr("disabled").find(".spinner-border").remove();
    $addToCart.removeClass("is-adding is-added");

    if (data && data.message && data.status === 422) {
      var $toast = $(".ajaxcart-toast");

      $toast.find(".toast-body").html(data.description);
      $toast.toast("show");
    }
  };

  cartModalAdded = function (lineItem) {
    if (!cartModalHeaderTemplate) {
      return;
    }

    var image = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";

    if (lineItem.image != null) {
      image = lineItem.image;
    }

    updateModalRecommendations(lineItem);

    var count = $('#count_quantity [data-variant_id="' + lineItem.variant_id + '"]').data("count_quantity");
    var disabled = "";

    if (count !== undefined && lineItem.quantity >= count) {
      disabled = "disabled";
    }

    var data = {
      name: lineItem.product_title,
      image: image,
      discount: lineItem.discounts,
      variant_id: lineItem.variant_id,
      variant: lineItem.variant_title,
      options: lineItem.options_with_values,
      price_discount: wpbingo.Currency.formatMoney(lineItem.original_line_price, settings.moneyFormat),
      final_line_price: wpbingo.Currency.formatMoney(lineItem.final_line_price, settings.moneyFormat),
      final_price: wpbingo.Currency.formatMoney(lineItem.final_price, settings.moneyFormat),
      quantity: lineItem.quantity,
      disabled: disabled,
    };

    $body.append(cartModalHeaderTemplate(data));

    if (data.variant != null) {
      for (var j in data.options) {
        $(".js-cart-modal .variant").append("<span>" + data.options[j].name + " : " + data.options[j].value + "</span>");
      }
    }

    if (data.discount.length > 0) {
      for (var discountIndex in data.discount) {
        $(".js-cart-modal .discount").text(data.discount[discountIndex].title);
      }

      $("#form-modal-addtocart .modalcart__line_price .price_discount").html(
        wpbingo.Currency.formatMoney(lineItem.original_line_price, settings.moneyFormat),
      );
    } else {
      $(".js-cart-modal .discount").empty();
      $("#form-modal-addtocart .modalcart__line_price .price_discount").empty();
    }

    $(".js-cart-modal").fadeIn(400);

    setTimeout(function () {
      $(".js-cart-modal .cart-modal__inner").addClass("show");
    }, 400);
  };

  updateModalRecommendations = function (lineItem) {
    var baseUrl = routes.product_recommendations_url;
    var productId = lineItem.product_id;
    var recommendationsSectionUrl = baseUrl + "?section_id=product-recommendations&product_id=" + productId + "&limit=6";

    $.get(recommendationsSectionUrl).then(function (section) {
      var recommendationsMarkup = $(section).html();
      $(".cart-modal-recommendations").html(recommendationsMarkup);

      var $element = $(".js-product-recommendations", $(".cart-modal-recommendations"));
      wpbingo.elementslickCarousel($element);

      if ($(".bwp_currency").length > 0) {
        Currency.Currency_customer(true);
      }
    });
  };

  cartUpdateCallback = function (cart, added) {
    currentCart = cart;
    updateCountPrice(cart);

    if ($(".js-drawer").length > 0 || $cartContainer.length > 0) {
      buildCart(cart);

      if (added) {
        $body.trigger("drawer.open");
      }
    }
  };

  formatSubscriptionRenewalDate = function (dateString, subscriptionType, currentMonth) {
    var parts = dateString.split(" ");
    var dayNum = parseInt(parts[0], 10);
    var month = parts[1];
    var monthIndex = new Date(month + " 1, 2000").getMonth();
    var renewalMonth = monthIndex + 1;
    var year = new Date().getFullYear();

    if (subscriptionType === "yearly") {
      year++;
    } else if (renewalMonth < currentMonth) {
      year++;
    }

    function getOrdinal(n) {
      if (n > 3 && n < 21) return "th";

      switch (n % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    }

    return month + " " + dayNum + getOrdinal(dayNum) + ", " + year;
  };

  updateCartSubscriptionInfo = function (sellingPlanID, firstBox) {
    var cartItemSubscriptionType = "yearly";
    var cartItemSubscriptionFrequency = "Yearly";
    var isAnnualSubscription = true;

    if (sellingPlanID == "693843067206" || sellingPlanID == "693843099974") {
      cartItemSubscriptionType = "quarterly";
      cartItemSubscriptionFrequency = "Every 3 months";
      isAnnualSubscription = false;
    }

    var cartItemSubscriptionBillingType = cartItemSubscriptionType === "quarterly" ? "Quarterly Billing" : "Yearly Billing";
    var cartItemFirstBoxType = firstBox.includes("Current Season") ? "current" : "next";
    var cartItemSubscriptionSeason;
    var cartItemSubscriptionProduct;
    var cartItemSubscriptionNextProduct;
    var cartItemSubscriptionMonths;
    var cartItemSubscriptionProductDesc = "Seed, feed and root support";

    if (firstBox.includes("Spring")) {
      cartItemSubscriptionSeason = "spring";
      cartItemSubscriptionProduct = "Spring Prepare";
      cartItemSubscriptionNextProduct = "Summer Protect";
      cartItemSubscriptionMonths = "Mar-May";
    } else if (firstBox.includes("Summer")) {
      cartItemSubscriptionSeason = "summer";
      cartItemSubscriptionProduct = "Summer Protect";
      cartItemSubscriptionNextProduct = "Autumn Preserve";
      cartItemSubscriptionMonths = "Jun-Aug";
    } else if (firstBox.includes("Autumn")) {
      cartItemSubscriptionSeason = "autumn";
      cartItemSubscriptionProduct = "Autumn Preserve";
      cartItemSubscriptionNextProduct = "Winter Bundle";
      cartItemSubscriptionMonths = "Sep-Nov";
    } else {
      cartItemSubscriptionSeason = "winter";
      cartItemSubscriptionProduct = "Winter Bundle";
      cartItemSubscriptionNextProduct = "Spring Prepare";
      cartItemSubscriptionMonths = "Dec-Feb";
      cartItemSubscriptionProductDesc = "Seasonal advice, lawn care samples and expert tips";
    }

    var cartItemSubscriptionRenewalDate = renewalDates[currentMonth][cartItemSubscriptionType][cartItemFirstBoxType];
    var cartItemNextRechargeDate = formatSubscriptionRenewalDate(cartItemSubscriptionRenewalDate, cartItemSubscriptionType, currentMonth);
    var cartItemSubscriptionNotice;
    var cartItemToolTipContent;

    if (cartItemSubscriptionType == "quarterly") {
      cartItemSubscriptionNotice =
        "Your subscription includes " +
        cartItemSubscriptionProduct +
        " and will automatically continue into " +
        cartItemSubscriptionNextProduct +
        " on " +
        cartItemSubscriptionRenewalDate +
        ". To avoid receiving " +
        cartItemSubscriptionNextProduct +
        ", cancel before " +
        cartItemSubscriptionRenewalDate +
        ".";
    } else {
      cartItemSubscriptionNotice =
        "Your yearly subscription includes all four seasonal boxes and renews on " +
        cartItemSubscriptionRenewalDate +
        " next year. To avoid renewal, cancel before " +
        cartItemSubscriptionRenewalDate +
        ".";

      cartItemToolTipContent =
        "Your subscription renews on " +
        cartItemSubscriptionRenewalDate +
        " each year, not on the anniversary of your purchase, as the " +
        cartItemSubscriptionSeason.charAt(0).toUpperCase() +
        cartItemSubscriptionSeason.slice(1) +
        " Box starts each new subscription cycle. To avoid renewal, please cancel your subscription before " +
        cartItemSubscriptionRenewalDate +
        ".";
    }

    return {
      type: cartItemSubscriptionType,
      billingType: cartItemSubscriptionBillingType,
      frequency: cartItemSubscriptionFrequency,
      firstBox: cartItemFirstBoxType,
      season: cartItemSubscriptionSeason,
      months: cartItemSubscriptionMonths,
      currentSeasonProduct: cartItemSubscriptionProduct,
      description: cartItemSubscriptionProductDesc,
      rechargeDate: cartItemNextRechargeDate,
      notice: cartItemSubscriptionNotice,
      annualToolTipContent: cartItemToolTipContent,
      isAnnualSubscription: isAnnualSubscription,
    };
  };

  buildCart = function (cart) {
    currentCart = cart;
    $cartContainer.empty();

    if (cart.item_count === 0) {
      $cartContainer.append(
        '<p class="cart-empty-message">' + wpbingo.strings.cartEmpty + "</p>\n" + '<p class="cookie-message">' + wpbingo.strings.cartCookies + "</p>",
      );
      $(".js-drawer .drawer__title .count").text("0");
      $("#mini-cart-title .cart-items-count").text("0");
      $(".shipping-bar-cart").addClass("hidden");
      cartCallback(cart);
      return;
    }

    // Generate cart message
    const productIds = cart.items.map((item) => item.product_id);

    cart.cartShippingInfo = "Tax included. Shipping calculated at checkout"; // Default

    if (productIds.length > 0 && productIds.every((id) => id === tyl_product)) {
      cart.cartShippingInfo =
        "Delivery costs are £3.90 for Mainland UK and £7.90 for UK remote areas (including Northern Ireland, Scottish Highlands and remote locations).";
    } else if (productIds.length > 0 && productIds.every((id) => id === ss_product)) {
      cart.cartShippingInfo =
        "Delivery costs are £2.90 per box for Mainland UK and £5.90 per box for UK remote areas (including Northern Ireland, Scottish Highlands and remote locations). ";
    }

    var sortedItems = cart.items.map(function (item, idx) {
      return {
        originalLine: idx + 1,
        item: item,
      };
    });

    sortedItems.sort(function (a, b) {
      return a.item.product_title.localeCompare(b.item.product_title);
    });

    var items = [];

    $.each(sortedItems, function (index, sorted) {
      var cartItem = sorted.item;
      var originalLine = sorted.originalLine;
      var prodId = cartItem.product_id;
      var prodImg;
      var unitPrice = null;
      var disabled = "";
      var firstBox = null;
      var subscriptionInfo = null;
      var sellingPlanID = null;
      var shortDesc = null;
      var variantId = cartItem.variant_id;
      var count = $('#count_quantity [data-variant_id="' + variantId + '"]').data("count_quantity");
      var properties = cleanProperties(cartItem.properties);

      if (count !== undefined && cartItem.quantity >= count) {
        disabled = "disabled";
      }

      if (cartItem.image !== null) {
        prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_compact$1").replace("http:", "");
      } else {
        prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      $.each(properties, function (key, value) {
        if (key.includes("First Box")) {
          firstBox = value;
        }
      });

      if (cartItem.line_level_discount_allocations.length !== 0) {
        for (var discount in cartItem.line_level_discount_allocations) {
          var amount = cartItem.line_level_discount_allocations[discount].amount;
          cartItem.line_level_discount_allocations[discount].formattedAmount = wpbingo.Currency.formatMoney(amount, settings.moneyFormat);
        }
      }

      if (cart.cart_level_discount_applications.length !== 0) {
        for (var cartDiscount in cart.cart_level_discount_applications) {
          var cartAmount = cart.cart_level_discount_applications[cartDiscount].total_allocated_amount;
          cart.cart_level_discount_applications[cartDiscount].formattedAmount = wpbingo.Currency.formatMoney(cartAmount, settings.moneyFormat);
        }
      }

      if (cartItem.unit_price_measurement) {
        unitPrice = {
          addRefererenceValue: cartItem.unit_price_measurement.reference_value !== 1,
          price: wpbingo.Currency.formatMoney(cartItem.unit_price, settings.moneyFormat),
          reference_value: cartItem.unit_price_measurement.reference_value,
          reference_unit: cartItem.unit_price_measurement.reference_unit,
        };
      }

      if (cartItem.selling_plan_allocation) {
        sellingPlanID = cartItem.selling_plan_allocation.selling_plan.id;

        if (prodId == 15563267309894 && firstBox !== null) {
          subscriptionInfo = updateCartSubscriptionInfo(sellingPlanID, firstBox);
        }
      }

      if (prodId == 15549548462406) {
        shortDesc = "Repair, strengthen and revive your lawn.";
      } else {
        shortDesc = cartItem.product_description;
      }

      items.push({
        key: cartItem.key,
        line: originalLine,
        productId: prodId,
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title === null ? false : true,
        variant: cartItem.variant,
        options: cartItem.options_with_values,
        variant_id: cartItem.variant_id,
        properties: properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        handle: cartItem.handle,
        price: wpbingo.Currency.formatMoney(cartItem.original_line_price, settings.moneyFormat),
        discountedPrice: wpbingo.Currency.formatMoney(cartItem.final_line_price, settings.moneyFormat),
        discounts: cartItem.line_level_discount_allocations,
        discountsApplied: cartItem.line_level_discount_allocations.length !== 0,
        vendor: cartItem.vendor,
        unitPrice: unitPrice,
        disabled: disabled,
        subscriptionInfo: subscriptionInfo,
        shortDesc: shortDesc,
      });
    });

    var data = {
      items: items,
      note: cart.note,
      totalPrice: wpbingo.Currency.formatMoney(cart.total_price, settings.moneyFormat),
      cartDiscounts: cart.cart_level_discount_applications,
      cartDiscountsApplied: cart.cart_level_discount_applications.length !== 0,
      cartShippingInfo: cart.cartShippingInfo,
    };

    if (cartTemplate) {
      $cartContainer.append(cartTemplate(data));
    }

    afterCartRender(cart, data);
  };

  cartCallback = function () {
    $body.removeClass("ajaxcart--is-loading");

    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }

    $body.trigger("drawer.footer");
  };

  adjustCart = function () {
    $body.on("click", ".drawer__quantity .ajaxcart__qty-adjust", function () {
      if (isUpdating || $(this).closest("#form-modal-addtocart").length) {
        return;
      }

      var $el = $(this);
      var line = $el.data("line");
      var $qtySelector = $el.siblings(".ajaxcart__qty-num");
      var qty = validateQty(parseInt($qtySelector.val().replace(/\D/g, "")));

      if ($el.hasClass("ajaxcart__qty--plus")) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    $body.on("change", ".ajaxcart__qty-num", function () {
      if (isUpdating || $(this).closest("#form-modal-addtocart").length) {
        return;
      }

      var $el = $(this);
      var id = $el.data("variant_id");
      var count = $('#count_quantity [data-variant_id="' + id + '"]').data("count_quantity");
      var line = $el.data("line");
      var qty = validateQty(parseInt($el.val().replace(/\D/g, "")));

      if (count !== undefined && qty >= count) {
        qty = count;
        $el.val(qty);
      }

      if (line) {
        updateQuantity(line, qty);
      }
    });

    $body.on("submit", "form.ajaxcart", function (evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    $body.on("focus", ".drawer__quantity .ajaxcart__qty-adjust", function () {
      var $el = $(this);

      setTimeout(function () {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      var $row = getCartRowsByLine(line).addClass("is-loading");

      if (qty === 0) {
        $row.parent().addClass("is-removed");
      }

      ShopifyAPI.changeItem(line, qty, adjustCartCallback);
    }
  };

  adjustCartCallback = function (cart) {
    currentCart = cart;
    updateCountPrice(cart);
    buildCart(cart);
    isUpdating = false;
  };

  function updateModalQuantity(qty) {
    if (isUpdating) {
      return;
    }

    var id = $("#form-modal-addtocart input[data-modal-variant]").val();
    var line = getCartLineByVariantId(id);
    var count = $('#count_quantity [data-variant_id="' + id + '"]').data("count_quantity");
    var $modalQuantity = $("#form-modal-addtocart .modalcart__quantity");
    var $qtyInput = $modalQuantity.find("input");

    qty = validateQty(parseInt(qty, 10));

    if (count !== undefined && qty >= count) {
      qty = count;
      $modalQuantity.find(".ajaxcart__qty-adjust.wpbingo-qty__adjust--plus").prop("disabled", true);
    } else {
      $modalQuantity.find(".ajaxcart__qty-adjust.wpbingo-qty__adjust--plus").prop("disabled", false);
    }

    $modalQuantity.find(".ajaxcart__qty-adjust.wpbingo-qty__adjust--minus").prop("disabled", qty <= 1);
    $qtyInput.val(qty);

    if (!line) {
      return;
    }

    isUpdating = true;
    $("#form-modal-addtocart .cart-modal__middle").addClass("load_modal");
    ShopifyAPI.changeItem(line, qty, function (cart) {
      adjustCartCallback(cart);
      $("#form-modal-addtocart .cart-modal__middle").removeClass("load_modal");
    });
  }

  function getCartLineByVariantId(variantId) {
    if (!currentCart || !currentCart.items) {
      return null;
    }

    for (var i = 0; i < currentCart.items.length; i++) {
      if (variantId == currentCart.items[i].variant_id) {
        return i + 1;
      }
    }

    return null;
  }

  function getCartRowsByLine(line) {
    return $('.ajaxcart__product[data-line="' + line + '"]');
  }

  function cleanProperties(properties) {
    var clean = {};

    if (properties === null) {
      return clean;
    }

    $.each(properties, function (key, value) {
      if (key.charAt(0) !== "_" && value) {
        clean[key] = value;
      }
    });

    return clean;
  }

  function afterCartRender(cart, data) {
    cartCallback(cart);

    if (data.note) {
      $(".cart-table .cart-note__input textarea").val(data.note);
    }

    var discountCode = wpbingo.getCookie("wpbingo_discount");

    if (discountCode) {
      $(".cart-table .discount_code_input").val(discountCode);
      $(".js-drawer .discount_code_input").val(discountCode);
    }

    $(".js-drawer .drawer__title .count").text(cart.item_count);
    $("#mini-cart-title .cart-items-count").text(cart.item_count);

    updateShippingBar(cart);
    updatePreOrderState(data);

    if ($(".bwp_currency").length > 0) {
      Currency.Currency_customer(true);
    }
  }

  function updateShippingBar(cart) {
    $(".shipping-bar-cart").removeClass("hidden");

    if (!$(".shipping-bar-cart").length) {
      return;
    }

    var priceShippingBar = $(".shipping-bar-cart").data("price_shipping_bar");

    if (priceShippingBar > cart.total_price && priceShippingBar != 0) {
      var minusSpend = priceShippingBar - cart.total_price;
      var spend = wpbingo.Currency.formatMoney(minusSpend, settings.moneyFormat);
      var percent = (cart.total_price / priceShippingBar) * 100;

      $(".shipping-bar-cart .title-spend .spend").html(spend);
      $(".shipping-bar-cart .shipping-progress").css("width", percent + "%");
      $(".shipping-bar-cart .title-shipping").addClass("hide");
      $(".shipping-bar-cart .title-spend").removeClass("hide");
      $(".shipping-bar-cart").removeClass("full");
      $("[data-cart-container]").removeClass("fire-done");
      $("#fire_work").addClass("hide");
    } else {
      $(".shipping-bar-cart .title-shipping").removeClass("hide");
      $(".shipping-bar-cart .title-spend").addClass("hide");
      $(".shipping-bar-cart .shipping-progress").css("width", "100%");
      $(".shipping-bar-cart").addClass("full");

      if (!$("[data-cart-container]").hasClass("fire-done")) {
        $("[data-cart-container]").addClass("fire");
      }

      if ($("[data-cart-container]").hasClass("fire")) {
        $("#fire_work").removeClass("hide");

        if (typeof confettiLoop === "function") {
          confettiLoop();
        }
      }

      setTimeout(function () {
        $("[data-cart-container]").addClass("fire-done");
        $("[data-cart-container]").removeClass("fire");
      }, 1000);

      setTimeout(function () {
        $("#fire_work").addClass("hide");
      }, 5000);
    }
  }

  function updatePreOrderState(data) {
    $(".pre_order-cart >span").each(function () {
      var id = $(this).data("handle");

      for (var i in data.items) {
        if (data.items[i].variant_id == id) {
          $('.ajaxcart__product[data-line="' + data.items[i].line + '"] .pre_order').removeClass("hide");
        }
      }
    });
  }

  function announceCartAddition(lineItem) {
    var liveRegion = document.getElementById("cart-live-region");

    if (!liveRegion) {
      return;
    }

    liveRegion.textContent = "";

    setTimeout(function () {
      liveRegion.textContent = lineItem.title + " added to basket.";
    }, 100);
  }

  validateQty = function (qty) {
    if (!(parseFloat(qty) === parseInt(qty) && !isNaN(qty))) {
      qty = 1;
    }

    return qty;
  };

  module = {
    init: init,
    load: loadCart,
  };

  return module;
})(ajaxCart || {}, jQuery);

wpbingo.drawerCart = (function (module) {
  var $body, $drawer, drawerCloseSelector, headerCartSelector, drawerIsOpen, $lastFocusedElement, $liveRegion;

  var init, drawerOpen, drawerClose, drawerFooter, trapFocus, releaseFocus;

  var classes = {
    open: "drawer--open",
  };

  init = function () {
    $body = $("body");
    $drawer = $(".js-drawer");
    drawerCloseSelector = ".js-drawer-close";
    headerCartSelector = ".js-header-cart";
    drawerIsOpen = false;

    /* Create a global live region once */
    if (!$("#cart-live-region").length) {
      $liveRegion = $('<div id="cart-live-region" class="sr-only" role="status" aria-live="polite"></div>');
      $("body").append($liveRegion);
    } else {
      $liveRegion = $("#cart-live-region");
    }

    $body.on("drawer.open", function (evt) {
      drawerOpen(evt);
    });

    $body.on("drawer.close", function (evt) {
      drawerClose(evt);
    });

    $body.on("drawer.footer", function () {
      drawerFooter();
    });

    $body.on("click", headerCartSelector, function (evt) {
      if (!$("body").hasClass("template-cart")) {
        evt.preventDefault();
        $body.trigger("drawer.open", evt);
      }
    });

    $body.on("click", drawerCloseSelector, function (evt) {
      evt.preventDefault();
      $body.trigger("drawer.close", evt);
    });

    /* Escape key support */
    $(document).on("keydown", function (e) {
      if (drawerIsOpen && e.key === "Escape") {
        $body.trigger("drawer.close", e);
      }
    });
  };

  let lastInputWasKeyboard = false;

  $(document)
    .on("keydown", function (e) {
      if (e.key === "Tab") {
        lastInputWasKeyboard = true;
      }
    })
    .on("pointerdown touchstart mousedown", function () {
      lastInputWasKeyboard = false;
    });

  drawerOpen = function (evt) {
    if (drawerIsOpen) {
      if (evt) {
        evt.preventDefault();
      }
      return;
    }

    if (evt) {
      evt.preventDefault();
    }

    $body.addClass(classes.open);
    drawerIsOpen = true;

    $lastFocusedElement = document.activeElement;

    $drawer.attr("aria-hidden", "false").attr("tabindex", "-1");

    /* Focus the dialog title */
    if (lastInputWasKeyboard) {
      var $close = $(".js-drawer-close");
      if ($close.length) {
        // Delay focus until drawer is visible
        setTimeout(function () {
          $close.trigger("focus");
        }, 500);
      } else {
        $drawer.trigger("focus");
      }
    }

    /* Screen reader announcement */
    $liveRegion.text("Mini basket opened");
  };

  drawerClose = function (evt) {
    if (!drawerIsOpen) return;

    if (evt) evt.preventDefault();

    drawerIsOpen = false;
    $body.removeClass(classes.open);

    $drawer.attr("aria-hidden", "true");

    if (lastInputWasKeyboard) {
      /* Restore focus to cart button */
      if ($lastFocusedElement) {
        $lastFocusedElement.focus();
      } else {
        $(headerCartSelector).focus();
      }
    }

    /* Screen reader announcement */
    $liveRegion.text("Mini basket closed");
  };

  drawerFooter = function () {
    if (!$drawer.hasClass("drawer--has-fixed-footer")) {
      return;
    }

    var $cartFooter = $(".ajaxcart__footer").removeAttr("style");
    var $cartInner = $(".ajaxcart__inner").removeAttr("style");
    var cartHeaderHeight = 105;
    var cartFooterHeight = $cartFooter.outerHeight();
    var cartInnerHeight = window.innerHeight - cartHeaderHeight - cartFooterHeight;
    $cartInner.css("height", cartInnerHeight);
    // $cartInner.css("bottom", cartFooterHeight);
    // $cartFooter.css("height", cartFooterHeight);
    $(".ajaxcart__info .button_note").on("click", function (e) {
      e.preventDefault();

      if ($(".ajaxcart__info .ajaxcart__note").hasClass("active")) {
        $(".ajaxcart__info .ajaxcart__note").removeClass("active");
      } else {
        $(".ajaxcart__info .ajaxcart__note").addClass("active");
      }
    });
    $(".ajaxcart__info .button_discount").on("click", function (e) {
      e.preventDefault();

      if ($(".ajaxcart__info .discount_code").hasClass("active")) {
        $(".ajaxcart__info .discount_code").removeClass("active");
      } else {
        $(".ajaxcart__info .discount_code").addClass("active");
      }
    });
    $(".ajaxcart__info .close-ajaxcart__info").on("click", function (e) {
      e.preventDefault();

      if ($(".ajaxcart__info .ajaxcart__info_content >div").hasClass("active")) {
        $(".ajaxcart__info .ajaxcart__info_content >div").removeClass("active");
      }
    });
    $(".ajaxcart__info .save").on("click", function (e) {
      e.preventDefault();

      if ($(".ajaxcart__info .ajaxcart__info_content >div").hasClass("active")) {
        $(".ajaxcart__info .ajaxcart__info_content >div").removeClass("active");
      }
    });
  };

  module = {
    init: init,
  };

  return module;
})();

wpbingo.variables = {
  productPageLoad: false,
  productPageSticky: true,
  mediaTablet: "screen and (max-width: 1024px)",
  mediaMobile: "screen and (max-width: 767px)",
  isTablet: false,
  isMobile: false,
};

wpbingo.initializeEvents = function () {
  var $body = $("body"),
    passwordToggle = ".js-password-toggle",
    scrollToTop = ".js-scroll-to-top",
    collectionSidebarToggle = ".js-sidebar-toggle";
  var classes = {
    passwordShow: "password-toggle--show",
  };
  $body.on("click", passwordToggle, function (e) {
    e.preventDefault();
    var $this = $(this);
    var $passwordField = $this.siblings(".form-control");
    var isShow = $this.hasClass(classes.passwordShow) ? true : false;
    if (isShow) {
      $this.removeClass(classes.passwordShow);
      $passwordField.attr("type", "password");
    } else {
      $this.addClass(classes.passwordShow);
      $passwordField.attr("type", "text");
    }
  });
  $body.on("click", scrollToTop, function (e) {
    e.preventDefault();
    $("body, html").stop().animate({ scrollTop: 0 }, "500");
  });
  $body.on("click", collectionSidebarToggle, function (evt) {
    evt.preventDefault();
    $body.toggleClass("collection-sidebar--open");
  });
  $(window).scroll(function () {
    if ($(window).scrollTop() >= 200) {
      $(scrollToTop).fadeIn();
    } else {
      $(scrollToTop).fadeOut();
    }
  });
};

wpbingo.setBreakpoints = function () {
  enquire.register(wpbingo.variables.mediaTablet, {
    match: function () {
      wpbingo.variables.isTablet = true;
    },
    unmatch: function () {
      wpbingo.variables.isTablet = false;
    },
  });
  enquire.register(wpbingo.variables.mediaMobile, {
    match: function () {
      wpbingo.variables.isMobile = true;
    },
    unmatch: function () {
      wpbingo.variables.isMobile = false;
    },
  });
};

wpbingo.updateSlickSwipe = function (element, allowSwipe) {
  if (!element.hasClass("slick-initialized")) {
    return;
  }
  var slickOptions = {
    accessibility: allowSwipe,
    draggable: allowSwipe,
    swipe: allowSwipe,
    touchMove: allowSwipe,
  };
  element.slick("slickSetOption", slickOptions, false);
};

wpbingo.showLoading = function () {
  $("body").append(wpbingo.loading != undefined && wpbingo.loading != "" ? wpbingo.loading : "");
};

wpbingo.hideLoading = function () {
  $(".wpbingo-loading").remove();
};

wpbingo.cartInit = function () {
  var $body = $("body");
  if (!wpbingo.cookiesEnabled()) {
    $body.addClass("cart--no-cookies");
  }
  if (wpbingo.settings.cartType == "modal" || wpbingo.settings.cartType == "drawer") {
    ajaxCart.init();
    ajaxCart.load();

    if (wpbingo.settings.cartType == "drawer") {
      wpbingo.drawerCart.init();
    }
  }
};

wpbingo.cookiesEnabled = function () {
  var cookieEnabled = navigator.cookieEnabled;

  if (!cookieEnabled) {
    document.cookie = "webcookie";
    cookieEnabled = document.cookie.indexOf("webcookie") !== -1;
  }
  return cookieEnabled;
};
wpbingo.setCookie = function (cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toGMTString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
};
wpbingo.getCookie = function (cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var cookieArray = decodedCookie.split(";");
  for (var i = 0; i < cookieArray.length; i++) {
    var cookieItem = cookieArray[i];
    while (cookieItem.charAt(0) === " ") {
      cookieItem = cookieItem.substring(1);
    }
    if (cookieItem.indexOf(name) === 0) {
      return cookieItem.substring(name.length, cookieItem.length);
    }
  }
  return "";
};

wpbingo.cookieConsent = function () {
  var cConsent = wpbingo.getCookie("cookie_consent"),
    cConsentSelector = $(".cookie-consent"),
    cConsentDismiss = ".cookie-consent-dismiss";
  cConsentAgree = ".cookie-consent-agree";
  if (cConsent == "true" || cConsent == "false") {
    cConsentSelector.remove();
  } else {
    setTimeout(function () {
      cConsentSelector.addClass("active");
    }, 1500);
    if (cConsent == "") wpbingo.setCookie("cookie_consent", "", 10);
  }
  $("body").on("click", cConsentDismiss, function (e) {
    e.preventDefault();
    cConsentSelector.remove();
    wpbingo.setCookie("cookie_consent", false, 10);
  });
  $("body").on("click", cConsentAgree, function (e) {
    e.preventDefault();
    cConsentSelector.remove();
    wpbingo.setCookie("cookie_consent", true, 10);
  });
};

wpbingo.slideshow = function () {
  var slideshow = ".js-wpbingo-slideshow",
    fade = $(slideshow).data("fade"),
    autoplay = $(slideshow).data("autoplay"),
    autoplayInterval = $(slideshow).data("autoplayinterval"),
    autoplayNavigation = $(slideshow).data("navigation"),
    autoplayPagination = $(slideshow).data("pagination");
  var config = {
    fade: true,
    rows: 0,
    arrows: autoplayNavigation,
    autoplay: autoplay,
    rtl: wpbingo.rtl_slick(),
    autoplaySpeed: autoplayInterval,
  };
  fade === undefined || fade == null ? true : (config.fade = fade);
  autoplayInterval === undefined || autoplayInterval == null ? true : (config.autoplaySpeed = autoplayInterval);
  autoplayPagination === undefined || autoplayPagination == null || autoplayPagination != true ? (config.dots = false) : (config.dots = true);
  $(slideshow).slick(config);
};
wpbingo.rtl_slick = function () {
  if ($("body").hasClass("rtl")) {
    return true;
  } else {
    return false;
  }
};
wpbingo.slickCarousel = function () {
  var bwpCarousel = ".js-carousel";
  $(bwpCarousel).each(function () {
    var $element = $(this),
      nav = $element.data("nav"),
      dots = $element.data("dots"),
      draggable = $element.data("draggable") ? false : true,
      fade = $element.data("fade") ? true : false,
      center = $element.data("center"),
      infinite = $element.data("infinite"),
      autoplay = $element.data("autoplay"),
      autoplaySpeed = $element.data("autoplayspeed"),
      slidesToScroll = $element.data("slidestoscroll") ? $element.data("columns") : 1,
      columns = $element.data("columns"),
      column1440 = $element.data("column1440"),
      column1 = $element.data("column1"),
      column2 = $element.data("column2"),
      column3 = $element.data("column3"),
      column4 = $element.data("column4"),
      asNavFor = $element.data("asnavfor") ? $element.data("asnavfor") : false,
      rows = $element.data("rows");
    var config = {
      rtl: wpbingo.rtl_slick(),
      draggable: draggable,
      fade: fade,
      asNavFor: asNavFor,
      arrows: nav,
      slidesToShow: columns,
      slidesToScroll: slidesToScroll,
      responsive: [
        {
          breakpoint: 1441,
          settings: {
            slidesToShow: column1440,
            slidesToScroll: column1440,
          },
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: column1,
            slidesToScroll: column1,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: column2,
            slidesToScroll: column2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: column3,
            slidesToScroll: column3,
            vertical: false,
            verticalSwiping: false,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: column4,
            slidesToScroll: column4,
            vertical: false,
            verticalSwiping: false,
          },
        },
      ],
    };
    center === undefined || center == null || center != true ? (config.centerMode = false) : (config.centerMode = true);
    dots === undefined || dots == null || dots != true ? (config.dots = false) : (config.dots = true);
    infinite === undefined || infinite == null || infinite != true ? (config.infinite = false) : (config.infinite = true);
    if (autoplay) {
      config.autoplay = autoplay;
      config.autoplaySpeed = autoplaySpeed;
    }
    if (rows !== undefined && rows != null && rows != 1) {
      config.rows = rows;
      config.slidesPerRow = columnone;
      ((config.slidesToShow = 1),
        (config.responsive = [
          {
            breakpoint: 1025,
            settings: {
              slidesPerRow: columntwo,
              slidesToShow: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesPerRow: columnthree,
              slidesToShow: 1,
            },
          },
        ]));
    } else {
      config.rows = 0;
    }
    $element.slick(config);
    if ($(".slick-arrow", $element).length > 0) {
      var $prev = $(".slick-prev", $element).clone();
      $(".slick-prev", $element).remove();
      if ($element.parent().find(".slick-prev").length == 0) {
        $prev.prependTo($element.parent());
      }
      $prev.on("click", function () {
        $element.slick("slickPrev");
      });
      var $next = $(".slick-next", $element).clone();
      $(".slick-next", $element).remove();
      if ($element.parent().find(".slick-next").length == 0) {
        $next.appendTo($element.parent());
      }
      $next.on("click", function () {
        $element.slick("slickNext");
      });
    }
  });
  $(".product-tabs__nav-link").on("shown.bs.tab", function () {
    var productTabs = $(this).closest(".product-tabs");
    if (productTabs.find(bwpCarousel).length > 0) {
      productTabs.find(bwpCarousel).slick("setPosition");
    }
  });
};
wpbingo.elementslickCarousel = function ($element) {
  var nav = $element.data("nav"),
    infinite = $element.data("infinite"),
    columns = $element.data("columns") ? $element.data("columns") : 1,
    column1440 = $element.data("column1440"),
    column1 = $element.data("column1"),
    column2 = $element.data("column2"),
    column3 = $element.data("column3"),
    column4 = $element.data("column4"),
    rows = $element.data("rows");
  var config = {
    arrows: nav,
    slidesToShow: columns,
    slidesToScroll: columns,
    rtl: wpbingo.rtl_slick(),
    responsive: [
      {
        breakpoint: 1441,
        settings: {
          slidesToShow: column1440,
          slidesToScroll: column1440,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: column1,
          slidesToScroll: column1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: column2,
          slidesToScroll: column2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: column3,
          slidesToScroll: column3,
          vertical: false,
          verticalSwiping: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: column4,
          slidesToScroll: column4,
          vertical: false,
          verticalSwiping: false,
        },
      },
    ],
  };
  if (rows !== undefined && rows != null && rows != 1) {
    config.rows = rows;
    config.slidesPerRow = columnone;
    ((config.slidesToShow = 1),
      (config.responsive = [
        {
          breakpoint: 1025,
          settings: {
            slidesPerRow: columntwo,
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesPerRow: columnthree,
            slidesToShow: 1,
          },
        },
      ]));
  } else {
    config.rows = 0;
  }
  $element.slick(config);
  if ($(".slick-arrow", $element).length > 0) {
    var $prev = $(".slick-prev", $element).clone();
    $(".slick-prev", $element).remove();
    if ($element.parent().find(".slick-prev").length == 0) {
      $prev.prependTo($element.parent());
    }
    $prev.on("click", function () {
      $element.slick("slickPrev");
    });
    var $next = $(".slick-next", $element).clone();
    $(".slick-next", $element).remove();
    if ($element.parent().find(".slick-next").length == 0) {
      $next.appendTo($element.parent());
    }
    $next.on("click", function () {
      $element.slick("slickNext");
    });
  }
};
wpbingo.sticky_product = function () {
  var $parent = $(".template-product");
  if ($(".sticky-cart-single", $parent).length > 0) {
    var bwp_width = $(window).width();
    $(window).scroll(function () {
      var scroll_top = $(window).scrollTop();
      var offset_top = $(".product-single__buttons", $parent).offset().top;
      var offset_top2 = $(".bwp-footer").offset().top;
      var distance = offset_top - scroll_top;
      var distance2 = offset_top2 - scroll_top - $(window).height();
      if (distance <= 0) {
        $(".sticky-cart-single", $parent).addClass("sticky");
      } else {
        $(".sticky-cart-single", $parent).removeClass("sticky");
      }
      if ($(".sticky-cart-single", $parent).hasClass("sticky")) {
        if (distance2 <= 0) {
          $(".sticky-cart-single", $parent).removeClass("sticky");
        } else {
          $(".sticky-cart-single", $parent).addClass("sticky");
        }
      }
    });
  }
};
wpbingo.sticky_header = function () {
  if ($(".bwp-header").data("sticky_header")) {
    var current_scroll = 0;
    var height = $(".bwp-header").height();
    var height_mb = $(".bwp-header .header-mobile .header-top-mobile").height();
    if ($(".bwp-header-topbar").length > 0) {
      var height_topbar = $(".bwp-header-topbar").height();
    } else {
      var height_topbar = 0;
    }
    if ($(".bwp-header-campar").length > 0) {
      var height_campar = $(".bwp-header-campar").height();
    } else {
      var height_campar = 0;
    }
    $(window).scroll(function () {
      var next_scroll = $(this).scrollTop();
      if ($(window).width() > 1199) {
        if (next_scroll > height + height_topbar + height_campar) {
          $(".bwp-header").addClass("sticky");
          if ($("body").hasClass("template-index")) {
            if (!$(".bwp-header").hasClass("header-absolute")) {
              $(".bwp-header").css("padding-top", height + "px");
            }
          } else {
            $(".bwp-header").css("padding-top", height + "px");
          }
        } else {
          $(".bwp-header").removeClass("sticky");
          $(".bwp-header").removeAttr("style");
        }
      } else {
        if (next_scroll > height_mb + height_topbar + height_campar) {
          $(".bwp-header").addClass("sticky");
          $(".bwp-header").css("padding-top", height_mb + "px");
        } else {
          $(".bwp-header").removeClass("sticky");
          $(".bwp-header").removeAttr("style");
        }
      }
      current_scroll = next_scroll;
    });
  }
};
wpbingo.click_button = function () {
  $(".search-toggle").on("click", function () {
    if ($(".content-search-toggle").hasClass("active")) {
      $(".bwp-header-topbar ").removeClass("active-index");
      $("body").removeClass("active_search");
      $(".content-search-toggle").removeClass("show");
      setTimeout(function () {
        $(".content-search-toggle").removeClass("active");
      }, 300);
    } else {
      $(".content-search-toggle").addClass("active");
      $(".bwp-header-topbar ").addClass("active-index");
      $("body").addClass("active_search");
      setTimeout(function () {
        $(".content-search-toggle").addClass("show");
      }, 100);
    }
  });
  $("[data-close-search-toggle]").on("click", function () {
    if ($(".content-search-toggle").hasClass("active")) {
      $(".content-search-toggle").removeClass("show");
      $(".bwp-header-topbar ").removeClass("active-index");
      $("body").removeClass("active_search");
      setTimeout(function () {
        $(".content-search-toggle").removeClass("active");
      }, 300);
    } else {
      $(".content-search-toggle").addClass("active");
      $(".bwp-header-topbar ").addClass("active-index");
      $("body").addClass("active_search");
      setTimeout(function () {
        $(".content-search-toggle").addClass("show");
      }, 100);
    }
  });
  /*$(".title-size-guide").on("click", function () {
    let $sizeGuideOpen = $(this);
    if ($("#tend-size-guide").hasClass("active")) {
      $sizeGuideOpen.attr("aria-expanded", "false");
      $("#tend-size-guide").removeClass("active");
    } else {
      $sizeGuideOpen.attr("aria-expanded", "true");
      $("#tend-size-guide").addClass("active");

      // Focus the dialog title
      var $sizeGuideClose = $(".tend-size-content .title-size-guide");
      if ($sizeGuideClose.length) {
        // Delay focus until drawer is visible
        setTimeout(function () {
          $sizeGuideClose.trigger("focus");
        }, 500);
      } else {
        $(".tend-size-content").trigger("focus");
      }
    }
  });*/
  let lastInputWasKeyboard = false;

  $(document)
    .on("keydown", function (e) {
      if (e.key === "Tab") {
        lastInputWasKeyboard = true;
      }
    })
    .on("pointerdown touchstart mousedown", function () {
      lastInputWasKeyboard = false;
    });

  let $lastTrigger = null;

  $(".size-guide-open").on("click", function () {
    $lastTrigger = $(this);

    $(this).attr("aria-expanded", "true");
    $("#tend-size-guide").addClass("active");

    if (lastInputWasKeyboard) {
      setTimeout(function () {
        $(".size-guide-close").trigger("focus");
      }, 50);
    }
  });

  $(".size-guide-close").on("click", function () {
    $("#tend-size-guide").removeClass("active");

    if ($lastTrigger) {
      $lastTrigger.attr("aria-expanded", "false");
      if (lastInputWasKeyboard) {
        $lastTrigger.trigger("focus");
      }
    }
  });

  $(document).on("keydown", function (e) {
    if (e.key === "Escape" && $("#tend-size-guide").hasClass("active")) {
      $(".size-guide-close").trigger("click");
    }
  });

  $(".header-left").on("click", function () {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(".header-category", $(this)).hide(300);
    } else {
      $(this).addClass("active");
      $(".header-category", $(this)).show(500);
    }
  });
};
wpbingo.header_campar = function () {
  var header_campar = "";
  $(".bwp-header-campar .close-campbar").on("click", function () {
    wpbingo.setCookie("wpbingo_header_campar", 1, 1);
    $(".bwp-header-campar").slideUp();
  });
  header_campar = wpbingo.getCookie("wpbingo_header_campar");
  if (header_campar != 1) {
    $(".bwp-header-campar").removeClass("active");
    $(".bwp-header-campar").slideDown();
  }
};
wpbingo.customNumberInput = function () {
  var $body = $("body"),
    qtyAdjust = ".js-qty-adjust",
    qtyNumber = ".js-qty-number";

  var validateQty;

  $body.on("click", qtyAdjust, function () {
    var $el = $(this),
      $qtySelector = $el.siblings(qtyNumber),
      qty = parseInt($qtySelector.val().replace(/\D/g, ""));

    qty = validateQty(qty);

    if ($el.hasClass("wpbingo-qty__adjust--plus")) {
      qty += 1;
    } else {
      qty -= 1;
      if (qty <= 0) qty = 0;
      if (qty <= 0 && $qtySelector.attr("min") == "1") qty = 1;
    }

    $qtySelector.val(qty);

    /**
     * Update price value on product price and add to cart btn
     */
    updateBtnPriceText(qty);
  });

  $body.on("input change", qtyNumber, function () {
    var $input = $(this);
    var qtyInputVal = parseInt($input.val().replace(/\D/g, ""));

    qtyInputVal = validateQty(qtyInputVal);

    if (qtyInputVal < 1) {
      qtyInputVal = 1;
      $input.val(1);
    }

    updateBtnPriceText(qtyInputVal);
  });

  $body.on("focus", qtyAdjust, function () {
    var $el = $(this);
    setTimeout(function () {
      $el.select();
    }, 50);
  });

  $body.on("blur", qtyNumber, function () {
    var $input = $(this);
    var value = $.trim($input.val());

    if (value === "") {
      $input.val(1);
      updateBtnPriceText(1);
      return;
    }

    var qty = validateQty(parseInt(value.replace(/\D/g, ""), 10));

    if (qty < 1) {
      qty = 1;
    }

    $input.val(qty);
    updateBtnPriceText(qty);
  });

  validateQty = function (qty) {
    if (parseFloat(qty) === parseInt(qty) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      qty = 1;
    }
    return qty;
  };

  updateBtnPriceText = function (qty) {
    var variantPrice = parseFloat($(".js-product-price.product-single__price").attr("content")) * qty;
    $(".price_text").html("£" + variantPrice.toFixed(2));
  };
};
wpbingo.zoom_thumb = function () {
  if ($(".product-card .product-card__image-wrapper").hasClass("zoom")) {
    $(".product-card .product-card__image").zoom();
  }
};
wpbingo.update_variant_cartpage = (function () {
  var selectors = {
    body: "body",
    EditVariant: "[data-edit_variant-cart]",
    EditVariantTemplate: "#edit_variants-template",
    EditVariantBtn: ".cart-product-edit_variant",
    EditVariantContainer: "[data-edit_variant-cart-container]",
    EditVariantClose: "[data-edit_variant-cart-close]",
    EditVariantImages: "[data-edit_variant-images]",
    EditVariantVariant: ".js-edit_variant-option-selector",
    originalSelectorId: "[data-edit_variant-variant]",
    EditVariantProductPrice: ".js-edit_variant-product-price",
    EditVariantProductPriceCompare: ".js-edit_variant-product-price-compare",
    EditVariantQty: "[data-edit_variant-quantity]",
    EditVariantAvaiable: ".product-avaiable",
    EditVariantAvaiableInStock: ".product-avaiable--instock",
    EditVariantAvaiableOutStock: ".product-avaiable--outstock",
    EditVariantDetailsURL: ".js-qv-product-details",
  };
  function EditVariant(container) {
    this.$container = $(container);
    this.cache = {};
    this.productVariants = [];
    this.currentVariant = {};
    this.cacheSelectors();
    this.initializeEvents();
  }
  EditVariant.prototype = _.assignIn({}, EditVariant.prototype, {
    cacheSelectors: function () {
      this.cache = {
        $body: $("body"),
        $EditVariantContainer: this.$container.find(selectors.EditVariantContainer),
      };
    },

    initializeEvents: function () {
      var $this = this;
      $(selectors.body).on("click", selectors.EditVariantBtn, function (e) {
        e.preventDefault();
        var productHandle = $(this).data("handle");
        var qty = $(this).data("value");
        var line = $(this).data("line");
        var id_variant = $(this).data("id_variant");
        var $parent = $(this).closest(".content-edit_variant-popup");
        $(this).addClass("load-edit_variant");
        $(".image-popup", $parent).addClass("imagepopup_active");
        $("body").addClass("editv_overlay-layer");
        $.getJSON("/products/" + productHandle + ".js", function (product) {
          if (product.available) {
            $this.firstAvailableVariant(product.variants, $this);
          } else {
            $this.currentVariant = product.variants[0];
          }
          $(selectors.EditVariantBtn).removeClass("load-edit_variant");
          $this.buildEditVariant(product, qty, line, id_variant);
          var $element = $(".edit_variant-cart-container .content_product_detail .variants-wrapper");
          $($element).each(function () {
            var $this = $(this);
            var value = $("input:checked", $this).attr("value");
            $(".variants__label span", $this).html(value);
          });
          $(selectors.EditVariantContainer).on("change", selectors.EditVariantVariant, function (e) {
            $this.onVariantChange(id_variant);
          });
          if ($(window).width() < 767) {
            $(selectors.EditVariant).addClass("transform");
          } else {
            $(selectors.EditVariant).addClass("transform");
          }
        });
      });
      $(selectors.body).on("click", selectors.EditVariantClose, function (e) {
        if ($(window).width() < 767) {
          $(selectors.EditVariant).removeClass("transform");
          $("body").removeClass("editv_overlay-layer");
          setTimeout(function () {
            $("[data-edit_variant-cart-container]").empty();
          }, 300);
        } else {
          $(selectors.EditVariant).removeClass("transform");
          setTimeout(function () {
            $("body").removeClass("editv_overlay-layer");
            $("[data-edit_variant-cart-container]").empty();
          }, 300);
        }
      });
      $(selectors.body).on("click", function (e) {
        if ($(e.target).is("body.editv_overlay-layer")) {
          if ($(window).width() < 767) {
            $(selectors.EditVariant).removeClass("transform");
            $("body").removeClass("editv_overlay-layer");
            setTimeout(function () {
              $("[data-edit_variant-cart-container]").empty();
            }, 300);
          } else {
            $(selectors.EditVariant).removeClass("transform");
            setTimeout(function () {
              $("body").removeClass("editv_overlay-layer");
              $("[data-edit_variant-cart-container]").empty();
            }, 300);
          }
        }
      });
    },

    firstAvailableVariant: function (variants, global) {
      global.productVariants = variants;
      for (var i = 0; i < variants.length; i++) {
        var variant = variants[i];
        if (variant.available) {
          global.currentVariant = variant;
          break;
        }
      }
    },
    buildEditVariant: function (product, qty, line, id_variant) {
      var moneyFormat = wpbingo.strings.moneyFormat;
      var currentVariant = this.currentVariant;
      for (var key in product.variants) {
        if (id_variant == product.variants[key].id) {
          var currentVariant = product.variants[key];
        }
      }
      var source = $(selectors.EditVariantTemplate).html();
      var template = Handlebars.compile(source);
      var images = "";
      var price = "";
      var external = "";
      var qvObject = {
        id: product.id,
      };
      if (typeof product.media !== "undefined") {
        images += '<div class="edit_variant-images__list slick-carousel" data-edit_variant-images>';
        for (var i = 0; i < product.media.length; i++) {
          var media = product.media[i];
          if (media.media_type === "image") {
            if (i == 0) {
              images +=
                '<div class="slick-carousel__item show"><div class="edit_variant-images__item" data-media-id=' +
                media.id +
                '><img class="img-fluid" alt="' +
                product.title +
                '" src="' +
                media.src +
                '" /></div></div>';
            } else {
              images +=
                '<div class="slick-carousel__item"><div class="edit_variant-images__item" data-media-id=' +
                media.id +
                '><img class="img-fluid" alt="' +
                product.title +
                '" src="' +
                media.src +
                '" /></div></div>';
            }
          }
        }
        images += "</div>";
      }
      qvObject.variantID = currentVariant.id;
      qvObject.sku = currentVariant.sku !== null && currentVariant.sku !== "" ? currentVariant.sku : "N/A";
      qvObject.images = images;
      qvObject.title = product.title;
      qvObject.qty = qty;
      qvObject.line = line;
      qvObject.url = product.url;
      price += '<div class="price-container">';
      var productCompareClass = product.compare_at_price !== null ? "" : "d-none";
      price +=
        '<div class="js-edit_variant-product-price-compare product-single__price--compare-at ' +
        productCompareClass +
        '">' +
        wpbingo.Currency.formatMoney(product.compare_at_price, moneyFormat) +
        "</div>";
      price +=
        '<div class="js-edit_variant-product-price product-single__price">' + wpbingo.Currency.formatMoney(product.price, moneyFormat) + "</div>";
      price += '</div">';
      qvObject.price = price;
      qvObject.variants = this.buildVariant(product, id_variant);
      $(selectors.EditVariantContainer).html(template(qvObject));
      // AFTER BUILD HTML
      this.updateMedia(currentVariant);
      this.updateDetailsLink(currentVariant);
      $("#form-edit_variants-addtocart .btn--add-to-cart").on("click", function (e) {
        e.preventDefault();
        var $parent = $(this).closest(".product-edit_variants");
        $(this).removeClass("added");
        $(this).addClass("active");
        let addToCartForm = document.querySelector("#form-edit_variants-addtocart");
        let formData = new FormData(addToCartForm);
        var params = {
          type: "POST",
          url: "/cart/add.js",
          data: formData,
          processData: false,
          contentType: false,
          dataType: "json",
          success: function (cart) {
            var line = $parent.data("line") + 1;
            $("#form-edit_variants-addtocart .btn--add-to-cart").removeClass("active");
            $("#form-edit_variants-addtocart .btn--add-to-cart").addClass("added");
            setTimeout(function () {
              $("#form-edit_variants-addtocart .btn--add-to-cart").removeClass("added");
            }, 2000);
            ShopifyAPI.changeItem(line, 0);
            setTimeout(function () {
              ajaxCart.load();
            }, 300);
            if ($("body").hasClass("template-cart")) {
              setTimeout(function () {
                ajaxCartPage.load();
              }, 300);
            }
            setTimeout(function () {
              if ($(window).width() < 767) {
                $(selectors.EditVariant).removeClass("is-visible");
                $("body").removeClass("editv_overlay-layer");
                setTimeout(function () {
                  $("[data-edit_variant-cart-container]").empty();
                }, 300);
              } else {
                $(selectors.EditVariant).removeClass("is-visible");
                setTimeout(function () {
                  $(selectors.EditVariant).removeClass("transform");
                }, 500);
                setTimeout(function () {
                  $("body").removeClass("editv_overlay-layer");
                  $("[data-edit_variant-cart-container]").empty();
                }, 700);
              }
            }, 500);
          },
          error: function (XMLHttpRequest, textStatus) {
            if (typeof errorCallback === "function") {
              errorCallback(XMLHttpRequest, textStatus);
            } else {
              ShopifyAPI.onError(XMLHttpRequest, textStatus);
            }
          },
        };
        jQuery.ajax(params);
      });
      if ($(".bwp_currency").length > 0) {
        Currency.Currency_customer(true);
      }
    },
    convertToSlug: function (str) {
      return str
        .toLowerCase()
        .replace(/[^a-z0-9 -]/g, "")
        .replace(/\s+/g, "-")
        .replace(/-+/g, "-");
    },
    buildVariant: function (product, id_variant) {
      var result = "";
      var currentVariant = this.currentVariant;
      for (var key in product.variants) {
        if (id_variant == product.variants[key].id) {
          var currentVariant = product.variants[key];
        }
      }
      if (product.options[0].name !== "Title") {
        var options = product.options;
        for (var i = 0; i < options.length; i++) {
          var option = options[i];
          var optionIndex = i + 1;
          var type = "label";
          if (wpbingo.settings.filter_name_1 === option.name) {
            type = wpbingo.settings.select_filter_1;
          } else if (wpbingo.settings.filter_name_2 === option.name) {
            type = wpbingo.settings.select_filter_2;
          } else if (wpbingo.settings.filter_name_3 === option.name) {
            type = wpbingo.settings.select_filter_3;
          }
          result += '<div class="variants-wrapper product-form__item ' + type + '" data-edit_variants-variant-option="' + optionIndex + '">';
          result += '<label class="variants__label">' + option.name + ": <span></span></label>";
          result += '<div class="variants__options">';
          for (var j = 0; j < option.values.length; j++) {
            var value = option.values[j];
            var isDisable = true;
            var colorAttribute = "";
            // CHECK Product option is available or disabled
            for (var k = 0; k < this.productVariants.length; k++) {
              var variantCondition = this.productVariants[k];
              if (variantCondition.available) {
                if (i == 0 && variantCondition.option1 === value) {
                  isDisable = false;
                  break;
                } else if (i == 1 && variantCondition.option2 === value && variantCondition.option1 == currentVariant.option1) {
                  isDisable = false;
                  break;
                } else if (
                  i == 2 &&
                  variantCondition.option3 === value &&
                  variantCondition.option2 == currentVariant.option2 &&
                  variantCondition.option1 == currentVariant.option1
                ) {
                  isDisable = false;
                  break;
                }
              }
            }
            // RENDER Product option button
            result += '<div class="single-option-selector">';
            result += '<input type="radio" data-single-option-button';
            result += currentVariant.options[i] === value ? " checked " : " ";
            if (isDisable) {
              result += 'disabled="disabled"';
            }
            result += 'value="' + _.escape(value) + '" data-index="option' + optionIndex + '" name="option' + option.position + '" ';
            result += 'class="js-edit_variant-option-selector';
            if (isDisable) {
              result += " disabled";
            }
            result += '" id="edit_variants-product-option-' + i + "-" + value.toLowerCase() + '">';
            result +=
              '<label class="' +
              value +
              '" data-toggle="tooltip" title="' +
              value +
              '" for="edit_variants-product-option-' +
              i +
              "-" +
              value.toLowerCase() +
              '" ' +
              colorAttribute;
            if (isDisable) {
              result += ' class="disabled"';
            }
            result += ">" + value + '<span class="tool-tip">' + value + "</span></label>";
            result += "</div>";
          }
          result += "</div>";
          result += "</div>";
        }
      }
      return result;
    },
    createImageCarousel: function (product) {
      if (product.media.length > 1) {
        $(selectors.EditVariant).find(selectors.EditVariantImages).slick({
          infinite: false,
          rows: 0,
          fade: true,
          rtl: wpbingo.rtl_slick(),
        });
      }
    },
    getCurrentOptions: function () {
      var currentOptions = _.map($(selectors.EditVariantVariant, selectors.EditVariantContainer), function (element) {
        var $element = $(element);
        var type = $element.attr("type");
        var currentOption = {};
        if (type === "radio" || type === "checkbox") {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data("index");
            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data("index");
          return currentOption;
        }
      });
      currentOptions = _.compact(currentOptions);
      return currentOptions;
    },
    getVariantFromOptions: function () {
      var selectedValues = this.getCurrentOptions();
      var variants = this.productVariants;
      var found = _.find(variants, function (variant) {
        return selectedValues.every(function (values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });
      return found;
    },
    updateVariantsButton: function () {
      var selectedValues = this.getCurrentOptions();
      var variants = this.productVariants;
      for (var i = 2; i <= 3; i++) {
        if ($('[data-edit_variants-variant-option="' + i + '"]', selectors.EditVariantContainer).length) {
          $('[data-edit_variants-variant-option="' + i + '"] ' + selectors.EditVariantVariant, selectors.EditVariantContainer).each(function () {
            var $self = $(this);
            var optionValue = $self.val();
            var foundIndex;
            if (i === 2) {
              foundIndex = _.findIndex(variants, function (variant) {
                variant.option1 = variant.option1.toString();
                selectedValues[0].value = selectedValues[0].value.toString();
                variant.option2 = variant.option2.toString();
                optionValue = optionValue.toString();
                return variant.option1 === selectedValues[0].value && variant.option2 === optionValue && variant.available === true;
              });
            } else if (i === 3) {
              foundIndex = _.findIndex(variants, function (variant) {
                variant.option1 = variant.option1.toString();
                variant.option2 = variant.option2.toString();
                variant.option3 = variant.option3.toString();
                selectedValues[0].value = selectedValues[0].value.toString();
                selectedValues[1].value = selectedValues[1].value.toString();
                optionValue = optionValue.toString();
                return (
                  variant.option1 === selectedValues[0].value &&
                  variant.option2 === selectedValues[1].value &&
                  variant.option3 === optionValue &&
                  variant.available === true
                );
              });
            }
            if (foundIndex !== -1) {
              $self.removeAttr("disabled", "disabled").removeClass("disabled");
              $self.next("label").removeClass("disabled");
            } else {
              $self.attr("disabled", "disabled").addClass("disabled");
              $self.next("label").addClass("disabled");
            }
          });
        }
      }
    },
    updateVariantsButtonDisabed: function () {
      for (var i = 2; i <= 3; i++) {
        if ($('[data-edit_variants-variant-option="' + i + '"]', selectors.EditVariantContainer).length) {
          var isUpdate = false;
          $('[data-edit_variants-variant-option="' + i + '"] ' + selectors.EditVariantVariant, selectors.EditVariantContainer).each(function () {
            var $element = $(this);
            var type = $element.attr("type");
            if (type === "radio" || type === "checkbox") {
              if (this.checked && $element.hasClass("disabled")) {
                $element.prop("checked", false);
                isUpdate = true;
                return false;
              }
            }
          });
          $('[data-edit_variants-variant-option="' + i + '"] ' + selectors.EditVariantVariant, selectors.EditVariantContainer).each(function () {
            var $element = $(this);
            var type = $element.attr("type");
            if (isUpdate && (type === "radio" || type === "checkbox") && !$element.hasClass("disabled")) {
              $element.prop("checked", true);
              isUpdate = false;
              $element.trigger("change");
              return false;
            }
          });
        }
      }
    },
    updateMasterSelect: function (variant) {
      if (variant) {
        $(selectors.originalSelectorId, selectors.EditVariantContainer).val(variant.id);
      }
    },
    updateLabelvariant: function (variant) {
      var $element = $(".edit_variant-cart-container .content_product_detail .variants-wrapper");
      $($element).each(function () {
        var $this = $(this);
        var value = $("input:checked", $this).attr("value");
        $(".variants__label span", $this).html(value);
      });
    },
    updateMedia: function (variant) {
      if (variant && variant.featured_media && variant.featured_media.id) {
        $(".slick-carousel__item", selectors.EditVariantContainer).removeClass("show");
        $(selectors.EditVariantImages, selectors.EditVariantContainer)
          .find(".edit_variant-images__item")
          .each(function () {
            var imageID = $(this).data("media-id");
            if (variant.featured_media.id == imageID) {
              $(this).closest(".slick-carousel__item").addClass("show");
              var slickIndex = $(this).closest(".slick-carousel__item").data("slick-index");
              if (slickIndex !== undefined && slickIndex !== null) {
                $(selectors.EditVariantImages, selectors.EditVariantContainer).slick("slickGoTo", slickIndex);
              }
            }
          });
      }
    },

    updatePrice: function (variant) {
      var moneyFormat = wpbingo.strings.moneyFormat;
      if (!variant) {
        $(selectors.EditVariantProductPrice, selectors.EditVariantContainer).addClass("d-none");
        $(selectors.EditVariantProductPriceCompare, selectors.EditVariantContainer).addClass("d-none");
      } else {
        $(selectors.EditVariantProductPrice, selectors.EditVariantContainer).removeClass("d-none");
        $(selectors.EditVariantProductPriceCompare, selectors.EditVariantContainer).removeClass("d-none");
        $(selectors.EditVariantProductPrice, selectors.EditVariantContainer).html(wpbingo.Currency.formatMoney(variant.price, moneyFormat));
        if (variant.compare_at_price > variant.price) {
          $(selectors.EditVariantProductPriceCompare, selectors.EditVariantContainer)
            .html(wpbingo.Currency.formatMoney(variant.compare_at_price, moneyFormat))
            .removeClass("d-none");
          $(selectors.EditVariantProductPrice, selectors.EditVariantContainer).addClass("on-sale");
        } else {
          $(selectors.EditVariantProductPriceCompare, selectors.EditVariantContainer).addClass("d-none");
          $(selectors.EditVariantProductPrice, selectors.EditVariantContainer).removeClass("on-sale");
        }
      }
      if ($(".bwp_currency").length > 0) {
        Currency.Currency_customer(true);
      }
    },

    updateProductAvaiable: function (variant) {
      var classActive = "product-avaiable--active";
      var translations = wpbingo.strings;
      $(selectors.EditVariantAvaiable, selectors.EditVariantContainer).removeClass(classActive);
      if (variant) {
        if (variant.available) {
          $(selectors.EditVariantQty, selectors.EditVariantContainer).removeClass("d-none");
          $(selectors.EditVariantAvaiableInStock, selectors.EditVariantContainer).addClass(classActive);
        } else {
          $(selectors.EditVariantQty, selectors.EditVariantContainer).addClass("d-none");
          $(selectors.EditVariantAvaiableOutStock, selectors.EditVariantContainer).addClass(classActive);
        }
        // Button add to cart
        if (variant.available) {
          $(selectors.EditVariantContainer).find(".btn--add-to-cart").removeClass("disabled").prop("disabled", false);
          $(selectors.EditVariantContainer).find(".btn--add-to-cart .btn__text").html(translations.addToCart);
        } else {
          $(selectors.EditVariantContainer).find(".btn--add-to-cart").addClass("disabled").prop("disabled", true);
          $(selectors.EditVariantContainer).find(".btn--add-to-cart .btn__text").html(translations.soldOut);
        }
      } else {
        $(selectors.EditVariantQty, selectors.EditVariantContainer).addClass("d-none");
        $(selectors.EditVariantContainer).find(".btn--add-to-cart").addClass("disabled").prop("disabled", true);
        $(selectors.EditVariantContainer).find(".btn--add-to-cart .btn__text").html(translations.unavailable);
      }
    },

    updateDetailsLink: function (variant) {
      if (variant) {
        var productURL = $(selectors.EditVariantDetailsURL, selectors.EditVariantContainer).data("url") + "?variant=" + variant.id;
        $(selectors.EditVariantDetailsURL, selectors.EditVariantContainer).removeClass("d-none").attr("href", productURL);
      } else {
        $(selectors.EditVariantDetailsURL, selectors.EditVariantContainer).addClass("d-none");
      }
    },

    onVariantChange: function (id_variant) {
      var variant = this.getVariantFromOptions();
      if ($("[data-single-option-button]", selectors.EditVariantContainer).length) {
        this.updateVariantsButton();
        if (!variant || !variant.available) {
          this.updateVariantsButtonDisabed();
          return;
        }
      }
      setTimeout(function () {
        if (variant.id != id_variant) {
          $(".btn--add-to-cart", selectors.EditVariantContainer).prop("disabled", false);
        } else {
          $(".btn--add-to-cart", selectors.EditVariantContainer).prop("disabled", true);
        }
      }, 100);
      this.updateMasterSelect(variant);
      this.updateLabelvariant(variant);
      this.updateMedia(variant);
      this.updatePrice(variant);
      this.updateProductAvaiable(variant);
      this.updateDetailsLink(variant);
      this.currentVariant = variant;
    },
  });
  return EditVariant;
})();

if ($("body").hasClass("template-cart")) {
  var ajaxCartPage = (function (module, $) {
    "use strict";

    var init, loadCart;
    var settings, isUpdating, $body;
    var $cartWrapper, $cartContainer, $cartDesktopContainer, $cartMobileContainer, $cartCostSelector;
    var initializeEvents,
      updateCountPrice,
      cartUpdateCallback,
      formatSubscriptionRenewalDate,
      updateCartSubscriptionInfo,
      buildCart,
      cartCallback,
      adjustCart,
      adjustCartCallback,
      validateQty;

    var desktopTemplate;
    var mobileTemplate;
    var cartBreakpoint = window.matchMedia("(max-width: 767px)");
    var currentCart = null;

    var currentDate = new Date();
    var currentMonth = currentDate.getMonth() + 1;

    var renewalDates = {
      1: { quarterly: { current: "1 April", next: "1 May" }, yearly: { current: "1 December", next: "1 March" } },
      2: { quarterly: { current: "1 May", next: "1 June" }, yearly: { current: "1 December", next: "1 March" } },
      3: { quarterly: { current: "1 June", next: "1 July" }, yearly: { current: "1 March", next: "1 June" } },
      4: { quarterly: { current: "1 July", next: "1 August" }, yearly: { current: "1 March", next: "1 June" } },
      5: { quarterly: { current: "1 August", next: "1 September" }, yearly: { current: "1 March", next: "1 June" } },
      6: { quarterly: { current: "1 September", next: "1 October" }, yearly: { current: "1 June", next: "1 September" } },
      7: { quarterly: { current: "1 October", next: "1 November" }, yearly: { current: "1 June", next: "1 September" } },
      8: { quarterly: { current: "1 November", next: "1 December" }, yearly: { current: "1 June", next: "1 September" } },
      9: { quarterly: { current: "1 December", next: "1 January" }, yearly: { current: "1 September", next: "1 December" } },
      10: { quarterly: { current: "1 January", next: "1 February" }, yearly: { current: "1 September", next: "1 December" } },
      11: { quarterly: { current: "1 February", next: "1 March" }, yearly: { current: "1 September", next: "1 December" } },
      12: { quarterly: { current: "1 March", next: "1 April" }, yearly: { current: "1 December", next: "1 March" } },
    };

    init = function (options) {
      settings = {
        cartWrapper: "[data-cartpage-wrapper]",
        cartContainer: "[data-cartpage-container]",
        cartDesktopContainer: '[data-cartpage-container][data-cart-layout="desktop"]',
        cartMobileContainer: '[data-cartpage-container][data-cart-layout="mobile"]',
        cartCostSelector: ".cart-total__subtotal-price",
        cartRemoveSelector: ".cart-product-info__btn--remove",
        moneyFormat: "${{amount}}",
        disableAjaxCart: false,
        cartTemplate: "#cart-form-template",
        cartTemplateMobile: "#cart-form-template-mobile",
      };

      if (wpbingo.strings.moneyFormat !== undefined) {
        settings.moneyFormat = wpbingo.strings.moneyFormat;
      }

      $.extend(settings, options);

      $cartWrapper = $(settings.cartWrapper);
      $cartContainer = $(settings.cartContainer);
      $cartDesktopContainer = $(settings.cartDesktopContainer);
      $cartMobileContainer = $(settings.cartMobileContainer);
      $cartCostSelector = $(settings.cartCostSelector);
      $body = $("body");
      isUpdating = false;

      var desktopSource = $(settings.cartTemplate).html();
      var mobileSource = $(settings.cartTemplateMobile).html();

      desktopTemplate = desktopSource ? Handlebars.compile(desktopSource) : null;
      mobileTemplate = mobileSource ? Handlebars.compile(mobileSource) : null;

      activateVisibleCartInputs();

      if (cartBreakpoint.addEventListener) {
        cartBreakpoint.addEventListener("change", activateVisibleCartInputs);
      } else {
        cartBreakpoint.addListener(activateVisibleCartInputs);
      }

      initializeEvents();
      adjustCart();
    };

    initializeEvents = function () {
      $body.on("click", settings.cartRemoveSelector, function (e) {
        e.preventDefault();

        if (isUpdating) {
          return;
        }

        var $el = $(this);
        var line = $el.data("line");

        if (line) {
          getCartRowsByLine(line).addClass("is-loading");
          isUpdating = true;
          ShopifyAPI.changeItem(line, 0, adjustCartCallback);
        }
      });

      $body.on("click", ".cart-table .discount_code_apply", function (e) {
        e.preventDefault();
        ShopifyAPI.applyDiscount();
      });
    };

    loadCart = function () {
      ShopifyAPI.getCart(cartUpdateCallback);
    };

    updateCountPrice = function (cart) {
      if ($cartCostSelector.length) {
        $cartCostSelector.html(wpbingo.Currency.formatMoney(cart.total_price, settings.moneyFormat));
      }
    };

    cartUpdateCallback = function (cart) {
      currentCart = cart;
      buildCart(cart);
      afterCartRender(cart);
    };

    formatSubscriptionRenewalDate = function (dateString, subscriptionType, currentMonth) {
      var parts = dateString.split(" ");
      var dayNum = parseInt(parts[0], 10);
      var month = parts[1];
      var monthIndex = new Date(month + " 1, 2000").getMonth();
      var renewalMonth = monthIndex + 1;
      var year = new Date().getFullYear();

      if (subscriptionType === "yearly") {
        year++;
      } else if (renewalMonth < currentMonth) {
        year++;
      }

      function getOrdinal(n) {
        if (n > 3 && n < 21) return "th";

        switch (n % 10) {
          case 1:
            return "st";
          case 2:
            return "nd";
          case 3:
            return "rd";
          default:
            return "th";
        }
      }

      return month + " " + dayNum + getOrdinal(dayNum) + ", " + year;
    };

    updateCartSubscriptionInfo = function (sellingPlanID, firstBox) {
      var cartItemSubscriptionType = "yearly";
      var cartItemSubscriptionFrequency = "Yearly";
      var isAnnualSubscription = true;

      if (sellingPlanID == "693843067206" || sellingPlanID == "693843099974") {
        cartItemSubscriptionType = "quarterly";
        cartItemSubscriptionFrequency = "Every 3 months";
        isAnnualSubscription = false;
      }

      var cartItemSubscriptionBillingType = cartItemSubscriptionType === "quarterly" ? "Quarterly Billing" : "Yearly Billing";
      var cartItemFirstBoxType = firstBox.includes("Current Season") ? "current" : "next";
      var cartItemSubscriptionSeason;
      var cartItemSubscriptionProduct;
      var cartItemSubscriptionNextProduct;
      var cartItemSubscriptionMonths;
      var cartItemSubscriptionProductDesc = "Seed, feed and root support";

      if (firstBox.includes("Spring")) {
        cartItemSubscriptionSeason = "spring";
        cartItemSubscriptionProduct = "Spring Prepare";
        cartItemSubscriptionNextProduct = "Summer Protect";
        cartItemSubscriptionMonths = "Mar-May";
      } else if (firstBox.includes("Summer")) {
        cartItemSubscriptionSeason = "summer";
        cartItemSubscriptionProduct = "Summer Protect";
        cartItemSubscriptionNextProduct = "Autumn Preserve";
        cartItemSubscriptionMonths = "Jun-Aug";
      } else if (firstBox.includes("Autumn")) {
        cartItemSubscriptionSeason = "autumn";
        cartItemSubscriptionProduct = "Autumn Preserve";
        cartItemSubscriptionNextProduct = "Winter Bundle";
        cartItemSubscriptionMonths = "Sep-Nov";
      } else {
        cartItemSubscriptionSeason = "winter";
        cartItemSubscriptionProduct = "Winter Bundle";
        cartItemSubscriptionNextProduct = "Spring Prepare";
        cartItemSubscriptionMonths = "Dec-Feb";
        cartItemSubscriptionProductDesc = "Seasonal advice, lawn care samples and expert tips";
      }

      var cartItemSubscriptionRenewalDate = renewalDates[currentMonth][cartItemSubscriptionType][cartItemFirstBoxType];
      var cartItemNextRechargeDate = formatSubscriptionRenewalDate(cartItemSubscriptionRenewalDate, cartItemSubscriptionType, currentMonth);
      var cartItemSubscriptionNotice;
      var cartItemToolTipContent;

      if (cartItemSubscriptionType == "quarterly") {
        cartItemSubscriptionNotice =
          "Your subscription includes " +
          cartItemSubscriptionProduct +
          " and will automatically continue into " +
          cartItemSubscriptionNextProduct +
          " on " +
          cartItemSubscriptionRenewalDate +
          ". To avoid receiving " +
          cartItemSubscriptionNextProduct +
          ", cancel before " +
          cartItemSubscriptionRenewalDate +
          ".";
      } else {
        cartItemSubscriptionNotice =
          "Your yearly subscription includes all four seasonal boxes and renews on " +
          cartItemSubscriptionRenewalDate +
          " next year. To avoid renewal, cancel before " +
          cartItemSubscriptionRenewalDate +
          ".";

        cartItemToolTipContent =
          "Your subscription renews on " +
          cartItemSubscriptionRenewalDate +
          " each year, not on the anniversary of your purchase, as the " +
          cartItemSubscriptionSeason.charAt(0).toUpperCase() +
          cartItemSubscriptionSeason.slice(1) +
          " Box starts each new subscription cycle. To avoid renewal, please cancel your subscription before " +
          cartItemSubscriptionRenewalDate +
          ".";
      }

      return {
        type: cartItemSubscriptionType,
        billingType: cartItemSubscriptionBillingType,
        frequency: cartItemSubscriptionFrequency,
        firstBox: cartItemFirstBoxType,
        season: cartItemSubscriptionSeason,
        months: cartItemSubscriptionMonths,
        currentSeasonProduct: cartItemSubscriptionProduct,
        description: cartItemSubscriptionProductDesc,
        rechargeDate: cartItemNextRechargeDate,
        notice: cartItemSubscriptionNotice,
        annualToolTipContent: cartItemToolTipContent,
        isAnnualSubscription: isAnnualSubscription,
      };
    };

    buildCart = function (cart) {
      currentCart = cart;

      if ($cartWrapper.length) {
        $cartWrapper.removeAttr("data-liquid-rendered").removeData("liquid-rendered");
      }

      if (cart.item_count === 0) {
        clearCartItems();
        $(".js-drawer .drawer__title .count").text("0");
        $(".shipping-bar-cart").addClass("hidden");
        return;
      }

      var items = [];

      var sortedItems = cart.items.map(function (cartItem, index) {
        return {
          item: cartItem,
          originalLine: index + 1,
        };
      });

      sortedItems.sort(function (a, b) {
        // return a.item.product_title.localeCompare(b.item.product_title);
        return a.item.title.localeCompare(b.item.title);
      });

      $.each(sortedItems, function (index, sorted) {
        var cartItem = sorted.item;
        var originalLine = sorted.originalLine;
        var prodId = cartItem.product_id;
        var prodImg;
        var unitPrice = null;
        var disabled = "";
        var firstBox = null;
        var subscriptionInfo = null;
        var sellingPlanID = null;
        var shortDesc = null;
        var variantId = cartItem.variant_id;
        var count = $('#count_quantity [data-variant_id="' + variantId + '"]').data("count_quantity");

        if (cartItem.quantity == count) {
          disabled = "disabled";
        }

        if (cartItem.image !== null) {
          prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_120x$1").replace("http:", "");
        } else {
          prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
        }

        if (cartItem.properties !== null) {
          $.each(cartItem.properties, function (key, value) {
            if (key.charAt(0) === "_" || !value) {
              delete cartItem.properties[key];
            }

            if (key.includes("First Box")) {
              firstBox = value;
            }
          });
        }

        if (cartItem.line_level_discount_allocations.length !== 0) {
          for (var discount in cartItem.line_level_discount_allocations) {
            var amount = cartItem.line_level_discount_allocations[discount].amount;
            cartItem.line_level_discount_allocations[discount].formattedAmount = wpbingo.Currency.formatMoney(amount, settings.moneyFormat);
          }
        }

        if (cart.cart_level_discount_applications.length !== 0) {
          for (var cartDiscount in cart.cart_level_discount_applications) {
            var cartAmount = cart.cart_level_discount_applications[cartDiscount].total_allocated_amount;
            cart.cart_level_discount_applications[cartDiscount].formattedAmount = wpbingo.Currency.formatMoney(cartAmount, settings.moneyFormat);
          }
        }

        if (cartItem.unit_price_measurement) {
          unitPrice = {
            addRefererenceValue: cartItem.unit_price_measurement.reference_value !== 1,
            price: wpbingo.Currency.formatMoney(cartItem.unit_price, settings.moneyFormat),
            reference_value: cartItem.unit_price_measurement.reference_value,
            reference_unit: cartItem.unit_price_measurement.reference_unit,
          };
        }

        if (cartItem.selling_plan_allocation) {
          sellingPlanID = cartItem.selling_plan_allocation.selling_plan.id;

          if (prodId == 15563267309894 && firstBox !== null) {
            subscriptionInfo = updateCartSubscriptionInfo(sellingPlanID, firstBox);
          }
        }

        if (prodId == 15549548462406) {
          shortDesc = "Repair, strengthen and revive your lawn.";
        } else {
          shortDesc = cartItem.product_description;
        }

        items.push({
          key: cartItem.key,
          line: originalLine,
          productId: prodId,
          url: cartItem.url,
          img: prodImg,
          name: cartItem.product_title,
          variation: cartItem.variant_title,
          variant: cartItem.variant_title === null ? false : true,
          options: cartItem.options_with_values,
          variant_id: cartItem.variant_id,
          price: wpbingo.Currency.formatMoney(cartItem.price, settings.moneyFormat),
          discountprice: wpbingo.Currency.formatMoney(cartItem.original_line_price, settings.moneyFormat),
          finalPrice: wpbingo.Currency.formatMoney(cartItem.final_line_price, settings.moneyFormat),
          handle: cartItem.handle,
          properties: cartItem.properties,
          itemAdd: cartItem.quantity + 1,
          itemMinus: cartItem.quantity - 1,
          itemQty: cartItem.quantity,
          discounts: cartItem.line_level_discount_allocations,
          discountsApplied: cartItem.line_level_discount_allocations.length !== 0,
          vendor: cartItem.vendor,
          unitPrice: unitPrice,
          disabled: disabled,
          subscriptionInfo: subscriptionInfo,
          shortDesc: shortDesc,
        });
      });

      var data = {
        items: items,
        note: cart.note,
        totalPrice: wpbingo.Currency.formatMoney(cart.total_price, settings.moneyFormat),
        cartDiscounts: cart.cart_level_discount_applications,
        cartDiscountsApplied: cart.cart_level_discount_applications.length !== 0,
      };

      renderCartItems(data);
      updateShippingBar(cart);
      updatePreOrderState(data);
    };

    cartCallback = function () {
      if (window.Shopify && Shopify.StorefrontExpressButtons) {
        Shopify.StorefrontExpressButtons.initialize();
      }
    };

    adjustCart = function () {
      $body.on("click", "#cart-form .ajaxcart__qty-adjust", function () {
        if (isUpdating) {
          return;
        }

        var $el = $(this);
        var line = $el.data("line");
        var $qtySelector = $el.siblings(".ajaxcart__qty-num");
        var qty = parseInt($qtySelector.val().replace(/\D/g, ""));

        qty = validateQty(qty);

        if ($el.hasClass("ajaxcart__qty--plus")) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 0) qty = 0;
        }

        if (line) {
          updateQuantity(line, qty);
        } else {
          $qtySelector.val(qty);
        }
      });

      $body.on("change", "#cart-form .ajaxcart__qty-num", function () {
        if (isUpdating) {
          return;
        }

        var $el = $(this);
        var id = $el.data("variant_id");
        var count = $('#count_quantity [data-variant_id="' + id + '"]').data("count_quantity");
        var line = $el.data("line");
        var qty = parseInt($el.val().replace(/\D/g, ""));

        qty = validateQty(qty);

        if (count !== undefined && qty >= count) {
          qty = count;
          $el.val(qty);
        }

        if (line) {
          updateQuantity(line, qty);
        }
      });

      $body.on("submit", "#cart-form", function (evt) {
        if (isUpdating) {
          evt.preventDefault();
          return;
        }

        evt.preventDefault();
        ShopifyAPI.goToCheckout();
      });

      $body.on("focus", "#cart-form .ajaxcart__qty-adjust", function () {
        var $el = $(this);

        setTimeout(function () {
          $el.select();
        }, 50);
      });

      function updateQuantity(line, qty) {
        isUpdating = true;

        var $row = getCartRowsByLine(line).addClass("is-loading");

        if (qty === 0) {
          $row.parent().addClass("is-removed");
        }

        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }
    };

    function clearCartItems() {
      if ($cartDesktopContainer.length) {
        $cartDesktopContainer.empty();
      }

      if ($cartMobileContainer.length) {
        $cartMobileContainer.empty();
      }

      if (!$cartDesktopContainer.length && !$cartMobileContainer.length) {
        $cartContainer
          .empty()
          .append(
            '<p class="cart-empty-message">' +
              wpbingo.strings.cartEmpty +
              "</p>\n" +
              '<p class="cookie-message">' +
              wpbingo.strings.cartCookies +
              "</p>",
          );
      }
    }

    function renderCartItems(data) {
      if ($cartDesktopContainer.length && desktopTemplate) {
        $cartDesktopContainer.empty().append(desktopTemplate(data));
      }

      if ($cartMobileContainer.length && mobileTemplate) {
        $cartMobileContainer.empty().append(mobileTemplate(data));
      }

      if (!$cartDesktopContainer.length && !$cartMobileContainer.length) {
        var template = cartBreakpoint.matches ? mobileTemplate : desktopTemplate;

        if (template) {
          $cartContainer.empty().append(template(data));
        }
      }
    }

    function updateShippingBar(cart) {
      $(".shipping-bar-cart").removeClass("hidden");

      if (!$(".shipping-bar-cart").length) {
        return;
      }

      var priceShippingBar = $(".shipping-bar-cart").data("price_shipping_bar");

      if (priceShippingBar > cart.total_price && priceShippingBar != 0) {
        var minusSpend = priceShippingBar - cart.total_price;
        var spend = wpbingo.Currency.formatMoney(minusSpend, settings.moneyFormat);
        var percent = (cart.total_price / priceShippingBar) * 100;

        $(".shipping-bar-cart .title-spend .spend").html(spend);
        $(".shipping-bar-cart .shipping-progress").css("width", percent + "%");
        $(".shipping-bar-cart .title-shipping").addClass("hide");
        $(".shipping-bar-cart .title-spend").removeClass("hide");
        $(".shipping-bar-cart").removeClass("full");
        $(".shipping-bar-cart .shipping-progress").removeClass("fire-done");
        $("#fire_work").addClass("hide");
      } else {
        $(".shipping-bar-cart .title-shipping").removeClass("hide");
        $(".shipping-bar-cart .title-spend").addClass("hide");
        $(".shipping-bar-cart .shipping-progress").css("width", "100%");
        $(".shipping-bar-cart").addClass("full");

        if (!$(".shipping-bar-cart .shipping-progress").hasClass("fire-done")) {
          $(".shipping-bar-cart .shipping-progress").addClass("fire");
        }

        if ($(".shipping-bar-cart .shipping-progress").hasClass("fire")) {
          $("#fire_work").removeClass("hide");

          if (typeof confettiLoop === "function") {
            confettiLoop();
          }
        }

        setTimeout(function () {
          $(".shipping-bar-cart .shipping-progress").addClass("fire-done");
          $(".shipping-bar-cart .shipping-progress").removeClass("fire");
        }, 100);

        setTimeout(function () {
          $("#fire_work").addClass("hide");
        }, 5000);
      }
    }

    function updatePreOrderState(data) {
      $(".page-cart .pre_order-cart >span").each(function () {
        var id = $(this).data("handle");

        for (var i in data.items) {
          if (data.items[i].variant_id == id) {
            $('.page-cart .item-cart[data-line="' + data.items[i].line + '"] .pre_order').removeClass("hidden");
            $('.page-cart .mobile-cart-item[data-line="' + data.items[i].line + '"] .pre_order').removeClass("hidden");
          }
        }
      });
    }

    function toggleCartEmptyState(cart) {
      var hasItems = cart.item_count > 0;

      $(".page-cart .content-cart_page").toggleClass("hidden", !hasItems);
      $(".page-cart .page-cart__header").toggleClass("hidden", !hasItems);
      $(".page-cart .page-cart-empty").toggleClass("hidden", hasItems);
    }

    adjustCartCallback = function (cart) {
      currentCart = cart;
      buildCart(cart);
      afterCartRender(cart);

      if (typeof ajaxCart !== "undefined" && ajaxCart.load) {
        ajaxCart.load();
      }

      isUpdating = false;
    };

    function getCartRowsByLine(line) {
      return $('#cart-form .item-cart[data-line="' + line + '"], ' + '#cart-form .mobile-cart-item[data-line="' + line + '"]');
    }

    function activateVisibleCartInputs() {
      var isMobile = cartBreakpoint.matches;
      var $desktopInputs = $(".cart-layout--desktop .ajaxcart__qty-num");
      var $mobileInputs = $(".cart-layout--mobile .ajaxcart__qty-num");

      $desktopInputs.prop("disabled", isMobile).removeAttr("name");
      $mobileInputs.prop("disabled", !isMobile).removeAttr("name");

      if (isMobile) {
        $mobileInputs.attr("name", "updates[]");
      } else {
        $desktopInputs.attr("name", "updates[]");
      }
    }

    function afterCartRender(cart) {
      updateCountPrice(cart);
      toggleCartEmptyState(cart);
      activateVisibleCartInputs();

      cartCallback(cart);

      if ($(".bwp_currency").length > 0) {
        Currency.Currency_customer(true);
      }
    }

    validateQty = function (qty) {
      if (!(parseFloat(qty) === parseInt(qty) && !isNaN(qty))) {
        qty = 1;
      }

      return qty;
    };

    module = {
      init: init,
      load: loadCart,
    };

    return module;
  })(ajaxCartPage || {}, jQuery);

  wpbingo.ajax_cartpage = function () {
    ajaxCartPage.init();

    var hasLiquidCart =
      $("[data-cartpage-wrapper]").data("liquid-rendered") === true || $("[data-cartpage-container]").data("liquid-rendered") === true;

    if (!hasLiquidCart) {
      ajaxCartPage.load();
    }
  };
}

wpbingo.ajax_blogpage = (function () {
  var ajaxBreadcrumbs, ajaxPaging, ajaxLoadMore, ajaxSidebar;
  var init = function () {
    ajaxPaging();
    ajaxLoadMore();
    ajaxBreadcrumbs();
    ajaxSidebar();
  };
  ajaxLoadMore = function () {
    if ($(".page-blog .pagination-ajax-blog-loadmore").length) {
      $(".page-blog .pagination-ajax-blog-loadmore").on("click", "a", function (e) {
        e.preventDefault();
        var pageURL = $(this).attr("href");
        var newTitle = $(this).attr("title");
        var URL_array = $(this)
          .attr("href")
          .match(/page=\d+/g);
        var curret = parseInt(URL_array[0].match(/\d+/g));
        $(this).addClass("active");
        $("#pre-loading").addClass("load-product");
        $("#pre-loading .pre-loading__bar").css({ width: "40%" });
        var offset = $(this).offset().top;
        if (pageURL) {
          $.ajax({
            type: "get",
            url: pageURL,
            success: function (data) {
              document.title = newTitle;
              $(".page-blog .article__list").append($(data).find(".page-blog .article__list").html());
              $(".page-blog .pagination-ajax-blog-loadmore").replaceWith($(data).find(".page-blog .pagination-ajax-blog-loadmore"));
              $("#pre-loading .pre-loading__bar").css({ width: "100%" });
              $("body,html").animate(
                {
                  scrollTop: offset,
                },
                600,
              );
              setTimeout(function () {
                $("#pre-loading .pre-loading__bar").css({ width: "0" });
                $("#pre-loading").removeClass("load-product");
              }, 500);
              ajaxBreadcrumbs();
              ajaxSidebar();
              ajaxLoadMore();
              $(this).removeClass("active");
            },
            error: function (xhr, text) {
              console.log(text);
            },
          });
        }
      });
    }
  };
  ajaxPaging = function () {
    if ($(".page-blog .pagination-ajax-blog").length) {
      $(".page-blog .pagination-ajax-blog").on("click", "a", function (e) {
        e.preventDefault();
        var pageURL = $(this).attr("href");
        var newTitle = $(this).closest(".pagination-ajax-blog").attr("title");
        History.pushState(
          {
            param: Shopify.queryParams,
          },
          pageURL,
          pageURL,
        );
        $("#pre-loading").addClass("load-product");
        $("#pre-loading .pre-loading__bar").css({ width: "40%" });
        if (pageURL) {
          $.ajax({
            type: "get",
            url: pageURL,
            success: function (data) {
              document.title = newTitle;
              $(".page-blog").replaceWith($(data).find(".page-blog"));
              $("body,html").animate(
                {
                  scrollTop: $(".header").height() + $(".wpbingo-breadcrumbs").height(),
                },
                600,
              );
              $("#pre-loading .pre-loading__bar").css({ width: "100%" });
              setTimeout(function () {
                $("#pre-loading .pre-loading__bar").css({ width: "0" });
                $("#pre-loading").removeClass("load-product");
              }, 500);
              ajaxBreadcrumbs();
              ajaxSidebar();
              ajaxPaging();
            },
            error: function (xhr, text) {
              console.log(text);
            },
          });
        }
      });
    }
  };
  ajaxBreadcrumbs = function () {
    if ($(".wpbingo-breadcrumbs .wpbingo-blog-list").length) {
      var $categories_blog = $(".wpbingo-blog-list");
      $($categories_blog).on("click", "a", function (e) {
        e.preventDefault();
        var pageURL = $(this).attr("href");
        var newTitle = $(this).attr("title");
        $(this).closest(".item-blog").addClass("active");
        History.pushState(
          {
            param: Shopify.queryParams,
          },
          pageURL,
          pageURL,
        );
        delete Shopify.queryParams.page;
        $("#pre-loading").addClass("load-product");
        $("#pre-loading .pre-loading__bar").css({ width: "40%" });
        $.ajax({
          type: "get",
          url: pageURL,
          success: function (data) {
            document.title = newTitle;
            $(".page-blog").replaceWith($(data).find(".page-blog"));
            $(".wpbingo-breadcrumbs .wpbingo-blog-list").replaceWith($(data).find(".wpbingo-breadcrumbs .wpbingo-blog-list"));
            $("#pre-loading .pre-loading__bar").css({ width: "100%" });
            setTimeout(function () {
              $("#pre-loading .pre-loading__bar").css({ width: "0" });
              $("#pre-loading").removeClass("load-product");
            }, 500);
            ajaxBreadcrumbs();
            ajaxSidebar();
            ajaxPaging();
            ajaxLoadMore();
          },
          error: function (xhr, text) {
            console.log(text);
          },
        });
        $("body,html").animate(
          {
            scrollTop: $(".header").height() + $(".wpbingo-breadcrumbs").height(),
          },
          600,
        );
      });
    }
  };
  ajaxSidebar = function () {
    if ($(".page-blog .blog-sidebar .list-category").length) {
      var $categories_blog = $(".blog-sidebar .list-category");
      $($categories_blog).on("click", "a", function (e) {
        e.preventDefault();
        var pageURL = $(this).attr("href");
        var newTitle = $(this).attr("title");
        $(this).closest("li").addClass("active");
        History.pushState(
          {
            param: Shopify.queryParams,
          },
          pageURL,
          pageURL,
        );
        delete Shopify.queryParams.page;
        $("#pre-loading").addClass("load-product");
        $("#pre-loading .pre-loading__bar").css({ width: "40%" });
        $.ajax({
          type: "get",
          url: pageURL,
          success: function (data) {
            document.title = newTitle;
            $(".page-blog").replaceWith($(data).find(".page-blog"));
            $(".wpbingo-breadcrumbs .wpbingo-blog-list").replaceWith($(data).find(".wpbingo-breadcrumbs .wpbingo-blog-list"));
            $("#pre-loading .pre-loading__bar").css({ width: "100%" });
            setTimeout(function () {
              $("#pre-loading .pre-loading__bar").css({ width: "0" });
              $("#pre-loading").removeClass("load-product");
            }, 500);
            ajaxBreadcrumbs();
            ajaxSidebar();
            ajaxPaging();
            ajaxLoadMore();
          },
          error: function (xhr, text) {
            console.log(text);
          },
        });
        $("body,html").animate(
          {
            scrollTop: $(".header").height() + $(".wpbingo-breadcrumbs").height(),
          },
          600,
        );
      });
    }
  };
  return init;
})();
wpbingo.check_width_megamenu = function () {
  if ($(".menu-dropdown--mega.width_custom_pos").length > 0) {
    $(".menu-dropdown--mega.width_custom_pos .menu-dropdown__content--megamenu").each(function () {
      var left = $(this).offset().left;
      var width_left = $(this).width() + left;
      var $parent = $(this).closest(".width_custom_pos");
      if (width_left >= $(window).width()) {
        $parent.addClass("width_custom_pos_right");
      }
    });
  }
};
wpbingo.slick_mobile = function () {
  if ($(window).width() < 767) {
    $(".bwp-load-slick-mobile").each(function () {
      $(this).slick({
        infinite: true,
        slidesToShow: $(this).data("col1"),
        slidesToScroll: $(this).data("col1"),
        arrows: $(this).data("nav"),
        dots: $(this).data("dot"),
        autoplay: $(this).data("autoplay"),
        autoplaySpeed: 5000,
        rtl: wpbingo.rtl_slick(),
        responsive: [
          {
            breakpoint: 480,
            settings: {
              slidesToShow: $(this).data("col2"),
              slidesToScroll: $(this).data("col2"),
            },
          },
        ],
      });
    });
  }
};
wpbingo.accordion_footer = function () {
  if ($(".footer-center").hasClass("accordion") && $(window).width() < 767) {
    $(".accordion .content-toggle").each(function () {
      var toggle = $(".footer-block", $(this));
      $(".title-footer", $(this)).on("click", function () {
        var $parent = $(this).closest(".content-toggle");
        $parent.toggleClass("active");
        toggle.slideToggle();
      });
    });
  }
};
wpbingo.product_tab = function () {
  if ($(".wpbingo-section--product-tabs-grid").length > 0) {
    $(".wpbingo-section--product-tabs-grid .product-tabs__nav-link").each(function () {
      $(this).on("click", function () {
        var $parent = $(this).closest(".menu-dropdown");
        var $text = $(this).text();
        $("span", $parent).text($text);
      });
    });
  }
};
wpbingo.address_delete = function () {
  $(".address-delete").on("click", function () {
    var $el = $(this);
    var target = $el.data("target");
    var confirmMessage = $el.data("confirm-message");
    if (confirm(confirmMessage || "Are you sure you wish to delete this address?")) {
      Shopify.postLink(target, {
        parameters: { _method: "delete" },
      });
    }
  });
};
wpbingo.search_form = function () {
  $(".close-search-form", $(".header__search-form")).on("click", function (event) {
    var $parent = $(this).closest(".header__search-form");
    $(this).css("display", "none");
    $(".predictive-search-content", $parent).css("display", "none");
  });
};
wpbingo.init = function () {
  wpbingo.initializeEvents();
  wpbingo.setBreakpoints();
  wpbingo.cartInit();
  wpbingo.slideshow();
  wpbingo.slickCarousel();
  wpbingo.sticky_product();
  wpbingo.sticky_header();
  wpbingo.click_button();
  wpbingo.cookieConsent();
  wpbingo.header_campar();
  wpbingo.customNumberInput();
  wpbingo.zoom_thumb();
  if ($("body").hasClass("template-cart")) {
    wpbingo.ajax_cartpage();
  }
  wpbingo.ajax_blogpage();
  wpbingo.check_width_megamenu();
  wpbingo.slick_mobile();
  wpbingo.accordion_footer();
  wpbingo.product_tab();
  wpbingo.address_delete();
  wpbingo.search_form();
  new wpbingo.update_variant_cartpage(".js-edit_variants");
  if ($("body").hasClass("template-product")) {
    var $element = $(".product-single");
    var _data = $element.data();
    if (_data.layout_thumb != "slider") {
      $(".product-media__wrapper--video iframe").css("width", $(".product-single__main-media .mfp-image").width());
      $(".product-media__wrapper--video iframe").css("height", $(".product-single__main-media .mfp-image").height());
      $(".js-product-media-item model-viewer").css("width", $(".js-product-media").width());
      $(".js-product-media-item model-viewer").css("height", $(".mfp-image").height());
    }
  }
};

$(document).ready(function () {
  wpbingo.init();
  var sections = new wpbingo.Sections();
  sections.register("product-template", wpbingo.Product);
  sections.register("header-section", wpbingo.HeaderSection);
  sections.register("header-topbar-section", wpbingo.HeaderSection);
  sections.register("search", wpbingo.Search);
  if ($("body").hasClass("template-product")) {
    sections.register("product-template", Shopify.Products.showRecentlyViewed());
    sections.register("product-template", Shopify.Products.recordRecentlyViewed());
    var $element = $(".product-single");
    var _data = $element.data();
    if (_data.layout_thumb == "slider") {
      $(".product-media__wrapper--video iframe").css("width", $(".product-single__main-media #slick-slide11 .mfp-image").width());
      $(".product-media__wrapper--video iframe").css("height", $(".product-single__main-media #slick-slide11 .mfp-image").height());
      $(".js-product-media-item model-viewer").css("width", $(".product-single__main-media #slick-slide11 .mfp-image").width());
      $(".js-product-media-item model-viewer").css("height", $(".product-single__main-media #slick-slide11 .mfp-image").height());
    }
  }
  $("#pre-loading").addClass("loading-done");
  setTimeout(function () {
    $("#pre-loading").removeClass("loading-done");
    $("#pre-loading").removeClass("loading-page");
  }, 1300);
  if (window.Shopify.designMode) {
    $("body").addClass("designMode_active");
    document.addEventListener("shopify:section:load", function (event) {
      var sectionId = ".wpbingo-section--" + event.detail.sectionId;
      if ($(".js-carousel", sectionId).length > 0) {
        wpbingo.elementslickCarousel($(".js-carousel", sectionId));
      }
    });
    document.addEventListener("shopify:block:select", function (event) {
      var id = $("#" + event.detail.blockId + "");
      if (id.length > 0) {
        $(".block-card-mobi").removeClass("active");
        $(".product-card__buttons").addClass("hidden");
        id.addClass("active");
      } else {
        $(".block-card-mobi").removeClass("active");
        $(".product-card__buttons").removeClass("hidden");
      }
    });
  }
});
